function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var Transaction = require('../../lib/saito/transaction')["default"];
var Main = require('./lib/main');
var Manager = require('./lib/manager');
var Tweet = require('./lib/tweet');
var Tweets = require('./lib/tweets');
var Loader = require('./lib/loader');
var Notifications = require('./lib/notifications');
var RedSquareApi = require('./lib/redsquare-api');
var ComposeOverlay = require('./lib/ui/overlays/compose');
var TweetMenu = require('./lib/ui/overlays/tweet-menu');
var SettingsOverlay = require('./lib/ui/overlays/settings');
var Moderate = require('./lib/ui/moderate');
var SplashTemplate = require('./lib/splash.template');
var index = require('./index');
var RedSquare = /*#__PURE__*/function (_ModTemplate) {
  function RedSquare(app) {
    var _this;
    _classCallCheck(this, RedSquare);
    _this = _callSuper(this, RedSquare, [app]);
    _this.appname = 'Red Square';
    _this.name = 'RedSquare';
    _this.slug = 'redsquare';
    _this.description = 'Open Source Twitter-clone for the Saito Network';
    _this.categories = 'Social Entertainment';
    _this.status = 'prod';
    _this["class"] = 'app';
    _this.icon_fa = 'fas fa-square-full';

    //
    // enable shortlinks
    //
    _this.shortlinks_enabled = 1;
    _this.possibleHome = 1;
    _this.use_floating_plus = 1;
    _this.allowed_upload_types = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'image/webp'];

    //
    // tweet data structures
    //
    _this.tweets = {};
    _this.tweets_parents = {};
    _this.tweets_children = {};
    _this.tweets_timeline = [];
    _this.tweets_orphans = {};
    _this.profile_tweets = {};
    _this.tweet_archive_saves = {};
    _this.like_archive_saves = {};
    _this.retweet_archive_saves = {};
    _this.like_target_updates = {};
    _this.tweets_last_viewed_ts = 0;
    _this.tweets_local_synced_ts = 0;

    //
    // notifications data structures
    //
    _this.notifications = {};
    _this.notifications_timeline = [];
    _this.notifications_aggregate = {};
    _this.notifications_last_viewed_ts = 0;
    _this.notifications_earliest_like_ts = new Date().getTime();
    _this.notifications_earliest_retweet_ts = new Date().getTime();
    _this.notifications_latest_ts = 0;
    _this.notifications_contact_earliest_ts = {};
    _this.notifications_contact_latest_ts = {};

    //
    // This is the default Open Graph Card for Redsquare
    // If we have a link to a specific tweet, we will use a different object to populate the
    // generated html in the webserver
    //
    _this.social = _this.buildSocial({
      twitter: '@SaitoOfficial',
      title: '🟥 Saito RedSquare - Web3 Social Media',
      url: '/redsquare/',
      description: 'Peer to peer Web3 social media platform',
      image: 'https://saito.tech/wp-content/uploads/2022/04/saito_card.png'
    });
    _this.peers = [];

    //
    // UI components
    //
    _this.header = null;
    _this.main = null;
    _this.profile = null;
    _this.manager = null;
    _this.compose_overlay = new ComposeOverlay(app, _this);
    _this.redsquare_api = new RedSquareApi(app, _this);
    _this.tweet_menu = new TweetMenu(app, _this);
    _this.settings_overlay = new SettingsOverlay(app, _this);
    _this.moderate = new Moderate(app, _this);
    _this.moderator_mode = false;
    _this.show_splash = true;
    _this.poll_block_interval = 5;
    _this.blocks_since_poll = 0;

    // Enables banner / description editing via Profile-module events.
    _this.enable_profile_edits = true;
    _this.styles = ['/saito/saito.css', '/redsquare/style.css'];
    _this.postScripts = ['/saito/lib/emoji-picker/emoji-picker.js'];
    return _this;
  }
  _inherits(RedSquare, _ModTemplate);
  return _createClass(RedSquare, [{
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (!this.app.BROWSER || this.offerService) {
        services.push(this.app.network.createPeerService(null, 'redsquare', 'RedSquare Tweet Archive'));
      }
      return services;
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var _this2 = this;
        var key, store;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(RedSquare, "initialize", this, 3)([app]);
            case 1:
              if (this.publicKey) {
                this.peers.unshift(Loader.createPeerState('localhost', this.publicKey));
              }
              if (app.BROWSER) {
                this.manager = new Manager(app, this);
                this.app.connection.on('redsquare-new-post', function () {
                  var _this2$compose_overla;
                  (_this2$compose_overla = _this2.compose_overlay) === null || _this2$compose_overla === void 0 || _this2$compose_overla.open();
                });
                this.app.connection.on('redsquare-post-tweet', /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
                    var keys,
                      tx,
                      _args = arguments;
                    return _regenerator().w(function (_context) {
                      while (1) switch (_context.n) {
                        case 0:
                          keys = _args.length > 1 && _args[1] !== undefined ? _args[1] : [];
                          _context.n = 1;
                          return _this2.createTweetTransaction(data, keys);
                        case 1:
                          tx = _context.v;
                          _context.n = 2;
                          return tx.sign();
                        case 2:
                          _context.n = 3;
                          return _this2.app.network.propagateTransaction(tx);
                        case 3:
                          return _context.a(2);
                      }
                    }, _callee);
                  }));
                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
                key = this.publicKey || '';
                this.profile = {
                  publicKey: key,
                  name: key ? this.app.keychain.returnUsername(key) || "Anon-".concat(key.slice(0, 6)) : 'Anonymous',
                  handle: '',
                  bio: '',
                  avatar: key ? this.app.keychain.returnIdenticon(key) || '/saito/img/dreamscape.png' : '/saito/img/dreamscape.png',
                  banner: '',
                  can_edit: Boolean(this.enable_profile_edits && key)
                };
                this.loadOptions();
                this.app.connection.on('modtools-lists-updated', function () {
                  _this2.applyModerationUpdates();
                });
                this.app.connection.on('modtools-on-server-whitelist', function () {
                  _this2.enterModeratorMode();
                });
                this.app.connection.on('saito-notification', function () {
                  var _this2$manager;
                  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  var id = data.id != null ? String(data.id) : '';
                  if (id !== 'store-moderation') {
                    return;
                  }
                  var pending = Math.max(0, Number(data.pending) || 0);
                  var signature = 'store-moderation';
                  if (pending <= 0) {
                    _this2.removeNotification(signature);
                    _this2.removeTweet(signature);
                  } else {
                    var text = data.text != null && String(data.text).trim() !== '' ? String(data.text) : 'There are new listings on the Store to moderate.';
                    var href = data.href != null && String(data.href).trim() !== '' ? String(data.href).trim() : '/store/moderate';
                    var storeMod = _this2.app.modules.returnModule('Store');
                    var actorPublicKey = (storeMod === null || storeMod === void 0 ? void 0 : storeMod.store_public_key) || (storeMod === null || storeMod === void 0 ? void 0 : storeMod.publicKey) || '';
                    var existing = _this2.getTweet(signature);
                    var timestamp = Number(existing === null || existing === void 0 ? void 0 : existing.created_at) || Date.now();
                    var msg = {
                      module: _this2.name,
                      request: 'create tweet',
                      data: {
                        text: text,
                        ephemeral: true,
                        href: href
                      }
                    };
                    var tweet = _this2.addTweet({
                      signature: signature,
                      timestamp: timestamp,
                      from: actorPublicKey ? [{
                        publicKey: actorPublicKey
                      }] : [],
                      msg: msg,
                      returnMessage: function returnMessage() {
                        return msg;
                      }
                    });
                    if (tweet) {
                      _this2.addNotification({
                        signature: signature,
                        tweet_signature: signature,
                        type: 'store-moderation',
                        actor_publicKey: actorPublicKey,
                        actor_name: 'Store',
                        text: text,
                        created_at: timestamp
                      });
                    }
                  }
                  if (((_this2$manager = _this2.manager) === null || _this2$manager === void 0 ? void 0 : _this2$manager.mode) === 'notifications') {
                    _this2.manager.render();
                  }
                });
                store = this.app.modules.returnModule('Store');
                if (store) {
                  this.app.connection.emit('saito-notification', {
                    id: 'store-moderation',
                    text: 'There are new listings on the Store to moderate.',
                    href: '/store/moderate',
                    pending: store.listings_to_moderate
                  });
                }
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
    /**
     * Trusted by connected server — load flagged tweets for the review queue.
     */
  }, {
    key: "enterModeratorMode",
    value: function () {
      var _enterModeratorMode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this3 = this,
          _this$manager;
        var peers, results, bySignature, _iterator, _step, txs, _iterator2, _step2, tx, signature, _t, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (this.app.BROWSER) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.moderator_mode = true;
              peers = this.returnTweetArchivePeers();
              _context3.n = 2;
              return Promise.all(peers.map(function (peer) {
                return _this3.loadArchiveTransactions({
                  field1: 'RedSquare',
                  flagged: 1,
                  limit: 10
                }, peer);
              }));
            case 2:
              results = _context3.v;
              bySignature = new Map();
              _iterator = _createForOfIteratorHelper(results);
              _context3.p = 3;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context3.n = 14;
                break;
              }
              txs = _step.value;
              _iterator2 = _createForOfIteratorHelper(txs || []);
              _context3.p = 5;
              _iterator2.s();
            case 6:
              if ((_step2 = _iterator2.n()).done) {
                _context3.n = 10;
                break;
              }
              tx = _step2.value;
              if (tx) {
                _context3.n = 7;
                break;
              }
              return _context3.a(3, 9);
            case 7:
              if (!(typeof tx.decryptMessage === 'function')) {
                _context3.n = 8;
                break;
              }
              _context3.n = 8;
              return tx.decryptMessage(this.app);
            case 8:
              signature = tx.signature != null ? String(tx.signature) : '';
              if (signature && !bySignature.has(signature)) {
                bySignature.set(signature, tx);
              }
            case 9:
              _context3.n = 6;
              break;
            case 10:
              _context3.n = 12;
              break;
            case 11:
              _context3.p = 11;
              _t = _context3.v;
              _iterator2.e(_t);
            case 12:
              _context3.p = 12;
              _iterator2.f();
              return _context3.f(12);
            case 13:
              _context3.n = 4;
              break;
            case 14:
              _context3.n = 16;
              break;
            case 15:
              _context3.p = 15;
              _t2 = _context3.v;
              _iterator.e(_t2);
            case 16:
              _context3.p = 16;
              _iterator.f();
              return _context3.f(16);
            case 17:
              this.moderate.setTransactions(Array.from(bySignature.values()));
              this.updateNotificationBadge();
              if (((_this$manager = this.manager) === null || _this$manager === void 0 ? void 0 : _this$manager.mode) === 'notifications') {
                this.moderate.render("".concat(this.manager.container, " .list[data-panel=\"notifications\"]"));
              }
            case 18:
              return _context3.a(2);
          }
        }, _callee3, this, [[5, 11, 12, 13], [3, 15, 16, 17]]);
      }));
      function enterModeratorMode() {
        return _enterModeratorMode.apply(this, arguments);
      }
      return enterModeratorMode;
    }()
    /**
     * Re-check stored tweets after ModTools lists change.
     * Marks moderated tweets and refreshes only those nodes — no timeline rebuild.
     */
  }, {
    key: "applyModerationUpdates",
    value: function applyModerationUpdates() {
      if (!this.app.BROWSER) {
        return;
      }
      var bySignature = new Map();
      for (var _i = 0, _Object$values = Object.values(this.tweets || {}); _i < _Object$values.length; _i++) {
        var tweet = _Object$values[_i];
        if (tweet !== null && tweet !== void 0 && tweet.signature) {
          bySignature.set(tweet.signature, tweet);
        }
      }
      for (var _i2 = 0, _Object$values2 = Object.values(this.profile_tweets || {}); _i2 < _Object$values2.length; _i2++) {
        var _tweet = _Object$values2[_i2];
        if (_tweet !== null && _tweet !== void 0 && _tweet.signature && !bySignature.has(_tweet.signature)) {
          bySignature.set(_tweet.signature, _tweet);
        }
      }
      var _iterator3 = _createForOfIteratorHelper(bySignature.values()),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _this$app$modules, _this$app$modules$mod;
          var _tweet2 = _step3.value;
          if (!_tweet2.tx) {
            continue;
          }
          var blocked = ((_this$app$modules = this.app.modules) === null || _this$app$modules === void 0 || (_this$app$modules$mod = _this$app$modules.moderate) === null || _this$app$modules$mod === void 0 ? void 0 : _this$app$modules$mod.call(_this$app$modules, _tweet2.tx, this.name)) === -1;
          if (blocked === Boolean(_tweet2.moderated)) {
            continue;
          }
          _tweet2.moderated = blocked;
          if (!blocked) {
            _tweet2.moderated_revealed = false;
          }
          if (typeof _tweet2.refresh === 'function') {
            _tweet2.refresh();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "loadOptions",
    value: function loadOptions() {
      if (!this.app.BROWSER) {
        return;
      }
      var rso = this.app.options.redsquare;
      if (rso) {
        this.show_splash = Object.prototype.hasOwnProperty.call(rso, 'show-splash') ? rso['show-splash'] : true;
      }
      var savedNotifications = Number(rso === null || rso === void 0 ? void 0 : rso.notifications_last_viewed_ts);
      if (savedNotifications > 0) {
        this.notifications_last_viewed_ts = savedNotifications;
      } else {
        this.notifications_last_viewed_ts = Date.now();
      }
      var savedTweets = Number(rso === null || rso === void 0 ? void 0 : rso.tweets_last_viewed_ts);
      this.tweets_last_viewed_ts = savedTweets > 0 ? savedTweets : 0;
      var savedLocalSynced = Number(rso === null || rso === void 0 ? void 0 : rso.tweets_local_synced_ts);
      this.tweets_local_synced_ts = savedLocalSynced > 0 ? savedLocalSynced : 0;
      if (!(savedNotifications > 0)) {
        this.saveOptions();
      }
    }
  }, {
    key: "saveOptions",
    value: function saveOptions() {
      if (!this.app.BROWSER) {
        return;
      }
      if (!this.app.options.redsquare) {
        this.app.options.redsquare = {};
      }
      delete this.app.options.redsquare.curated;
      this.app.options.redsquare['show-splash'] = this.show_splash;
      this.app.options.redsquare.notifications_last_viewed_ts = this.notifications_last_viewed_ts;
      this.app.options.redsquare.tweets_last_viewed_ts = Math.max(Number(this.app.options.redsquare.tweets_last_viewed_ts) || 0, Number(this.tweets_last_viewed_ts) || 0);
      this.app.options.redsquare.tweets_local_synced_ts = Math.max(Number(this.app.options.redsquare.tweets_local_synced_ts) || 0, Number(this.tweets_local_synced_ts) || 0);
      this.app.storage.saveOptions();
    }

    //
    // Primary browser startup path — fires when a peer advertising "redsquare" connects.
    // (Saito hook name is onPeerServiceUp, invoked once per peer service.)
    //
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, peer) {
        var service,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              service = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              if (!(!app.BROWSER || !this.browser_active)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (!(service.service !== 'redsquare')) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              this.registerPeer(peer);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onPeerServiceUp(_x3, _x4) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "onConnectionUnstable",
    value: function onConnectionUnstable(app, publicKey) {
      var source = this.peers.find(function (p) {
        return p.publicKey === publicKey && p.peer !== 'localhost';
      });
      if (source) {
        source.peer_disconnected = true;
      }
    }
  }, {
    key: "onNewBlock",
    value: function onNewBlock(blk, lc) {
      var _this4 = this;
      if (!this.app.BROWSER || !this.browser_active) {
        this.blocks_since_poll = 0;
        return;
      }
      if (!lc) {
        return;
      }
      this.blocks_since_poll++;
      if (this.blocks_since_poll < this.poll_block_interval) {
        return;
      }
      this.blocks_since_poll = 0;
      if (this.peers.length > 0) {
        this.loadTransactions('tweets', 'newer', function (result) {
          var _this4$manager, _this4$manager$onNewe;
          (_this4$manager = _this4.manager) === null || _this4$manager === void 0 || (_this4$manager$onNewe = _this4$manager.onNewerContentLoaded) === null || _this4$manager$onNewe === void 0 || _this4$manager$onNewe.call(_this4$manager, result, {
            announce: true
          });
        });
      }
      if (this.publicKey) {
        this.loadTransactions('notifications', 'newer', function (result) {
          var _this4$manager2, _this4$manager2$onNew;
          (_this4$manager2 = _this4.manager) === null || _this4$manager2 === void 0 || (_this4$manager2$onNew = _this4$manager2.onNewerContentLoaded) === null || _this4$manager2$onNew === void 0 || _this4$manager2$onNew.call(_this4$manager2, result);
        });
      }
    }
  }, {
    key: "registerPeer",
    value: function registerPeer(peer) {
      var publicKey = (peer === null || peer === void 0 ? void 0 : peer.publicKey) || '';
      if (!publicKey) {
        return false;
      }
      var existing = this.peers.find(function (p) {
        return p.publicKey === publicKey;
      });
      if (existing) {
        var connectionId = peer.id == null ? null : String(peer.id);
        var sameConnection = !existing.peer_disconnected && (connectionId !== null && existing.peer_connection_id != null ? connectionId === existing.peer_connection_id : existing.peer === peer);
        existing.peer = peer;
        existing.peer_connection_id = connectionId;
        existing.peer_disconnected = false;
        if (sameConnection) {
          return false;
        }
        if (existing.tweets_exhausted) {
          Loader.reopenTweetSource(existing);
        } else {
          // Keep partial history progress, but invalidate the old connection's responses.
          existing.tweets_history_version = (existing.tweets_history_version || 0) + 1;
        }
      } else {
        this.peers.push(_objectSpread(_objectSpread({}, Loader.createPeerState(peer, publicKey)), {}, {
          peer_connection_id: peer.id == null ? null : String(peer.id),
          peer_disconnected: false
        }));
      }

      // API consumers can register the service before our own service callback.
      // Notify here so whichever caller discovers the connection wakes the feed.
      if (this.app.BROWSER && this.browser_active) {
        var _this$manager2, _this$manager2$onPeer;
        (_this$manager2 = this.manager) === null || _this$manager2 === void 0 || (_this$manager2$onPeer = _this$manager2.onPeersUpdated) === null || _this$manager2$onPeer === void 0 || _this$manager2$onPeer.call(_this$manager2);
      }
      return true;
    }

    //
    // Canonical content-loading gateway.
    //
    // Tweets:
    //   newer / older — chronological multi-item retrieval
    //   local / remote / all — exact one-tweet lookup by { sig }
    // Notifications remain newer / older only.
    //
  }, {
    key: "loadTransactions",
    value: function loadTransactions(type, mode, callback) {
      var _this$app$keychain,
        _this$app$keychain$re,
        _this5 = this,
        _this$peers$;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (typeof callback !== 'function') {
        return;
      }
      if (type !== 'tweets' && type !== 'notifications') {
        callback({
          type: type,
          direction: mode,
          added: [],
          updated: [],
          ignored: [],
          exhausted: true
        });
        return;
      }
      var tweetModes = ['newer', 'older', 'local', 'remote', 'all'];
      var allowed = type === 'tweets' ? tweetModes : ['newer', 'older'];
      if (!allowed.includes(mode)) {
        callback({
          type: type,
          direction: mode,
          added: [],
          updated: [],
          ignored: [],
          exhausted: true
        });
        return;
      }
      if (type === 'tweets') {
        Loader.loadTweetTransactions(this, mode, callback, options);
        return;
      }
      var isOlder = mode === 'older';

      //
      // -------------------------------------------------------------------------
      // notifications (localhost archive only)
      // -------------------------------------------------------------------------
      //
      var busyKey = "notifications:".concat(mode);
      if (!this._load_busy) {
        this._load_busy = {};
      }
      if (this._load_busy[busyKey]) {
        this._load_busy[busyKey].push(callback);
        return;
      }
      this._load_busy[busyKey] = [callback];
      var collected = [];
      var added = [];
      var updated = [];
      var ignored = [];
      var contactKeys = Array.from(new Set((((_this$app$keychain = this.app.keychain) === null || _this$app$keychain === void 0 || (_this$app$keychain$re = _this$app$keychain.returnKeys) === null || _this$app$keychain$re === void 0 ? void 0 : _this$app$keychain$re.call(_this$app$keychain)) || []).map(function (key) {
        return key === null || key === void 0 ? void 0 : key.publicKey;
      }).filter(function (publicKey) {
        return publicKey && publicKey !== _this5.publicKey;
      })));
      var contactArchivePeer = ((_this$peers$ = this.peers[0]) === null || _this$peers$ === void 0 ? void 0 : _this$peers$.peer) || 'localhost';
      var exhausted = false;
      var queries = 0;
      var queries_done = 0;
      var finishNotifications = function finishNotifications() {
        if (collected.length === 0) {
          if (isOlder) {
            _this5.notifications_earliest_like_ts = 0;
            _this5.notifications_earliest_retweet_ts = 0;
          }
          exhausted = true;
        }
        for (var z = 0; z < collected.length; z++) {
          var tx = collected[z];
          if (!tx) {
            continue;
          }
          var working = typeof tx.toJson === 'function' ? new Transaction(undefined, tx.toJson()) : tx;
          if (!working) {
            continue;
          }
          if (typeof working.decryptMessage === 'function') {
            working.decryptMessage(_this5.app);
          }
          var signature = working.signature != null ? String(working.signature) : '';
          if (!signature) {
            continue;
          }
          var ts = Number(tx.timestamp) || Date.now();
          var hadNotification = _this5.hasNotification(signature);
          var notification = _this5.addNotification(working);
          if (!notification) {
            if (!ignored.includes(signature)) {
              ignored.push(signature);
            }
          } else if (notification.signature === signature && !hadNotification) {
            if (!added.includes(signature)) {
              added.push(signature);
            }
          } else if (notification.signature === signature && hadNotification) {
            if (!updated.includes(signature)) {
              updated.push(signature);
            }
          } else {
            if (!updated.includes(notification.signature)) {
              updated.push(notification.signature);
            }
            if (!ignored.includes(signature)) {
              ignored.push(signature);
            }
          }
          if (isOlder) {
            var txmsg = tx.returnMessage ? tx.returnMessage() : tx.msg || {};
            if (txmsg.request === 'like tweet') {
              if (ts < _this5.notifications_earliest_like_ts) {
                _this5.notifications_earliest_like_ts = ts;
              }
            } else if (txmsg.request === 'retweet') {
              if (ts < _this5.notifications_earliest_retweet_ts) {
                _this5.notifications_earliest_retweet_ts = ts;
              }
            }
          } else if (ts > _this5.notifications_latest_ts) {
            _this5.notifications_latest_ts = ts;
          }
        }
        var result = {
          type: type,
          direction: mode,
          added: added.slice(),
          updated: updated.slice(),
          ignored: ignored.slice(),
          exhausted: exhausted
        };
        var callbacks = _this5._load_busy[busyKey] || [];
        _this5._load_busy[busyKey] = null;
        var _iterator4 = _createForOfIteratorHelper(callbacks),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var cb = _step4.value;
            cb(result);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      };
      var onNotificationQueryDone = function onNotificationQueryDone() {
        queries_done++;
        if (queries_done >= queries) {
          finishNotifications();
        }
      };
      if (isOlder) {
        var _iterator5 = _createForOfIteratorHelper(contactKeys),
          _step5;
        try {
          var _loop = function _loop() {
            var publicKey = _step5.value;
            if (!Object.prototype.hasOwnProperty.call(_this5.notifications_contact_earliest_ts, publicKey)) {
              _this5.notifications_contact_earliest_ts[publicKey] = Date.now();
            }
            var earliestTs = _this5.notifications_contact_earliest_ts[publicKey];
            if (!earliestTs) {
              return 1; // continue
            }
            queries++;
            _this5.app.storage.loadTransactions({
              field1: 'RedSquare',
              field2: publicKey,
              created_earlier_than: earliestTs,
              limit: 10
            }, function (txs) {
              var rows = txs || [];
              if (rows.length === 0) {
                _this5.notifications_contact_earliest_ts[publicKey] = 0;
              }
              var _iterator8 = _createForOfIteratorHelper(rows),
                _step8;
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  var tx = _step8.value;
                  if (tx.timestamp < _this5.notifications_contact_earliest_ts[publicKey]) {
                    _this5.notifications_contact_earliest_ts[publicKey] = tx.timestamp;
                  }
                  collected.push(tx);
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
              onNotificationQueryDone();
            }, contactArchivePeer);
          };
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            if (_loop()) continue;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        if (this.notifications_earliest_like_ts) {
          queries++;
          this.app.storage.loadTransactions({
            field1: 'RedSquareLike',
            field3: this.publicKey,
            created_earlier_than: this.notifications_earliest_like_ts,
            limit: 10
          }, function (txs) {
            var _iterator6 = _createForOfIteratorHelper(txs || []),
              _step6;
            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var tx = _step6.value;
                if (tx.timestamp < _this5.notifications_earliest_like_ts) {
                  _this5.notifications_earliest_like_ts = tx.timestamp;
                }
                collected.push(tx);
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
            onNotificationQueryDone();
          }, 'localhost');
        }
        if (this.notifications_earliest_retweet_ts) {
          queries++;
          this.app.storage.loadTransactions({
            field1: 'RedSquareRetweet',
            field3: this.publicKey,
            created_earlier_than: this.notifications_earliest_retweet_ts,
            limit: 10
          }, function (txs) {
            var _iterator7 = _createForOfIteratorHelper(txs || []),
              _step7;
            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var tx = _step7.value;
                if (tx.timestamp < _this5.notifications_earliest_retweet_ts) {
                  _this5.notifications_earliest_retweet_ts = tx.timestamp;
                }
                collected.push(tx);
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
            onNotificationQueryDone();
          }, 'localhost');
        }
      } else {
        var _iterator9 = _createForOfIteratorHelper(contactKeys),
          _step9;
        try {
          var _loop2 = function _loop2() {
            var publicKey = _step9.value;
            var latestTs = _this5.notifications_contact_latest_ts[publicKey] || 0;
            queries++;
            _this5.app.storage.loadTransactions({
              field1: 'RedSquare',
              field2: publicKey,
              created_later_than: latestTs,
              limit: 10
            }, function (txs) {
              var _iterator10 = _createForOfIteratorHelper(txs || []),
                _step10;
              try {
                for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                  var tx = _step10.value;
                  var ts = Number(tx.timestamp) || 0;
                  if (ts > (_this5.notifications_contact_latest_ts[publicKey] || 0)) {
                    _this5.notifications_contact_latest_ts[publicKey] = ts;
                  }
                  collected.push(tx);
                }
              } catch (err) {
                _iterator10.e(err);
              } finally {
                _iterator10.f();
              }
              onNotificationQueryDone();
            }, contactArchivePeer);
          };
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
        queries++;
        this.app.storage.loadTransactions({
          field1: 'RedSquareLike',
          field3: this.publicKey,
          updated_later_than: this.notifications_latest_ts,
          limit: 10
        }, function (txs) {
          var _iterator0 = _createForOfIteratorHelper(txs || []),
            _step0;
          try {
            for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
              var tx = _step0.value;
              collected.push(tx);
            }
          } catch (err) {
            _iterator0.e(err);
          } finally {
            _iterator0.f();
          }
          onNotificationQueryDone();
        }, 'localhost');
        queries++;
        this.app.storage.loadTransactions({
          field1: 'RedSquareRetweet',
          field3: this.publicKey,
          updated_later_than: this.notifications_latest_ts,
          limit: 10
        }, function (txs) {
          var _iterator1 = _createForOfIteratorHelper(txs || []),
            _step1;
          try {
            for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
              var tx = _step1.value;
              collected.push(tx);
            }
          } catch (err) {
            _iterator1.e(err);
          } finally {
            _iterator1.f();
          }
          onNotificationQueryDone();
        }, 'localhost');
      }
      if (queries === 0) {
        var callbacks = this._load_busy[busyKey] || [];
        this._load_busy[busyKey] = null;
        var _iterator11 = _createForOfIteratorHelper(callbacks),
          _step11;
        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var cb = _step11.value;
            cb({
              type: type,
              direction: mode,
              added: [],
              updated: [],
              ignored: [],
              exhausted: true
            });
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
      }
    }
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app) {
        var _txmsg$data,
          _this6 = this;
        var tx,
          peer,
          mycallback,
          txmsg,
          obj,
          _args5 = arguments,
          _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              tx = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : null;
              peer = _args5.length > 2 ? _args5[2] : undefined;
              mycallback = _args5.length > 3 ? _args5[3] : undefined;
              if (!(tx == null)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, 0);
            case 1:
              txmsg = tx.returnMessage();
              if (txmsg.request) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, 0);
            case 2:
              if (!(!txmsg.module || txmsg.module === this.name)) {
                _context5.n = 16;
                break;
              }
              _t3 = txmsg.request;
              _context5.n = _t3 === 'like tweet' ? 3 : _t3 === 'retweet' ? 5 : _t3 === 'flag tweet' ? 7 : _t3 === 'review tweet' ? 9 : _t3 === 'edit tweet' ? 11 : _t3 === 'delete tweet' ? 13 : 15;
              break;
            case 3:
              _context5.n = 4;
              return this.receiveLikeTweetTransaction(tx);
            case 4:
              if (mycallback) {
                mycallback({});
              }
              return _context5.a(2, 1);
            case 5:
              _context5.n = 6;
              return this.receiveRetweetTransaction(tx);
            case 6:
              if (mycallback) {
                mycallback({});
              }
              return _context5.a(2, 1);
            case 7:
              _context5.n = 8;
              return this.receiveFlagTweetTransaction(tx);
            case 8:
              if (mycallback) {
                mycallback({});
              }
              return _context5.a(2, 1);
            case 9:
              _context5.n = 10;
              return this.receiveReviewTweetTransaction(tx);
            case 10:
              if (mycallback) {
                mycallback({});
              }
              return _context5.a(2, 1);
            case 11:
              _context5.n = 12;
              return this.receiveEditTweetTransaction(tx);
            case 12:
              if (mycallback) {
                mycallback({});
              }
              return _context5.a(2, 1);
            case 13:
              _context5.n = 14;
              return this.receiveDeleteTweetTransaction(tx);
            case 14:
              if (mycallback) {
                mycallback({});
              }
              return _context5.a(2, 1);
            case 15:
              return _context5.a(3, 16);
            case 16:
              if (!(txmsg.request === 'load tweets' && ((_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.created_earlier_than) != undefined)) {
                _context5.n = 18;
                break;
              }
              if (mycallback) {
                _context5.n = 17;
                break;
              }
              return _context5.a(2, 0);
            case 17:
              obj = {
                field1: 'RedSquare',
                flagged_ne: 1,
                field4: '',
                limit: 10,
                created_earlier_than: txmsg.data.created_earlier_than
              };
              this.app.storage.loadTransactions(obj, function (txs) {
                var serialized = [];
                var _iterator12 = _createForOfIteratorHelper(txs || []),
                  _step12;
                try {
                  for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                    var row = _step12.value;
                    serialized.push(row.serialize_to_web(_this6.app));
                  }
                } catch (err) {
                  _iterator12.e(err);
                } finally {
                  _iterator12.f();
                }
                mycallback(serialized);
              }, 'localhost');
              return _context5.a(2, 1);
            case 18:
              return _context5.a(2, _superPropGet(RedSquare, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee5, this);
      }));
      function handlePeerTransaction(_x5) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }() //
    // Tweet transaction construction
    //
  }, {
    key: "createTweetTransaction",
    value: function () {
      var _createTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var data,
          keys,
          payload,
          _i3,
          _Object$keys,
          key,
          newtx,
          _iterator13,
          _step13,
          _key,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              data = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
              keys = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : [];
              payload = {};
              if (data && _typeof(data) === 'object') {
                for (_i3 = 0, _Object$keys = Object.keys(data); _i3 < _Object$keys.length; _i3++) {
                  key = _Object$keys[_i3];
                  payload[key] = data[key];
                }
              }
              if (payload.text != null) {
                payload.text = String(payload.text);
              }
              if (payload.parent_id != null) {
                payload.parent_id = String(payload.parent_id);
              }
              if (payload.thread_id != null) {
                payload.thread_id = String(payload.thread_id);
              }
              if (payload.images != null) {
                payload.images = Array.isArray(payload.images) ? payload.images.slice() : [payload.images];
              }
              if (payload.mentions != null) {
                payload.mentions = Array.isArray(payload.mentions) ? payload.mentions.slice() : [payload.mentions];
              }
              _context6.n = 1;
              return this.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context6.v;
              newtx.msg = {
                module: this.name,
                request: 'create tweet',
                data: payload
              };
              _iterator13 = _createForOfIteratorHelper(keys);
              try {
                for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                  _key = _step13.value;
                  if (_key && _key !== this.publicKey) {
                    newtx.addTo(_key);
                  }
                }
              } catch (err) {
                _iterator13.e(err);
              } finally {
                _iterator13.f();
              }
              return _context6.a(2, newtx);
          }
        }, _callee6, this);
      }));
      function createTweetTransaction() {
        return _createTweetTransaction.apply(this, arguments);
      }
      return createTweetTransaction;
    }()
  }, {
    key: "createLikeTweetTransaction",
    value: function () {
      var _createLikeTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var data,
          keys,
          payload,
          _i4,
          _Object$keys2,
          key,
          newtx,
          _iterator14,
          _step14,
          _key2,
          _args7 = arguments;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              data = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
              keys = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : [];
              payload = {};
              if (data && _typeof(data) === 'object') {
                for (_i4 = 0, _Object$keys2 = Object.keys(data); _i4 < _Object$keys2.length; _i4++) {
                  key = _Object$keys2[_i4];
                  payload[key] = data[key];
                }
              }
              if (payload.signature != null) {
                payload.signature = String(payload.signature);
              }
              _context7.n = 1;
              return this.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context7.v;
              newtx.msg = {
                module: this.name,
                request: 'like tweet',
                data: payload
              };
              _iterator14 = _createForOfIteratorHelper(keys);
              try {
                for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                  _key2 = _step14.value;
                  if (_key2 && _key2 !== this.publicKey) {
                    newtx.addTo(_key2);
                  }
                }
              } catch (err) {
                _iterator14.e(err);
              } finally {
                _iterator14.f();
              }
              return _context7.a(2, newtx);
          }
        }, _callee7, this);
      }));
      function createLikeTweetTransaction() {
        return _createLikeTweetTransaction.apply(this, arguments);
      }
      return createLikeTweetTransaction;
    }()
  }, {
    key: "createRetweetTransaction",
    value: function () {
      var _createRetweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var data,
          keys,
          payload,
          _i5,
          _Object$keys3,
          key,
          newtx,
          _iterator15,
          _step15,
          _key3,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              data = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
              keys = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : [];
              payload = {};
              if (data && _typeof(data) === 'object') {
                for (_i5 = 0, _Object$keys3 = Object.keys(data); _i5 < _Object$keys3.length; _i5++) {
                  key = _Object$keys3[_i5];
                  payload[key] = data[key];
                }
              }
              if (payload.signature != null) {
                payload.signature = String(payload.signature);
              }
              _context8.n = 1;
              return this.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context8.v;
              newtx.msg = {
                module: this.name,
                request: 'retweet',
                data: payload
              };
              _iterator15 = _createForOfIteratorHelper(keys);
              try {
                for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                  _key3 = _step15.value;
                  if (_key3 && _key3 !== this.publicKey) {
                    newtx.addTo(_key3);
                  }
                }
              } catch (err) {
                _iterator15.e(err);
              } finally {
                _iterator15.f();
              }
              return _context8.a(2, newtx);
          }
        }, _callee8, this);
      }));
      function createRetweetTransaction() {
        return _createRetweetTransaction.apply(this, arguments);
      }
      return createRetweetTransaction;
    }()
  }, {
    key: "createFlagTweetTransaction",
    value: function () {
      var _createFlagTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var data,
          keys,
          payload,
          _i6,
          _Object$keys4,
          key,
          newtx,
          _iterator16,
          _step16,
          _key4,
          _args9 = arguments;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              data = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
              keys = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : [];
              payload = {};
              if (data && _typeof(data) === 'object') {
                for (_i6 = 0, _Object$keys4 = Object.keys(data); _i6 < _Object$keys4.length; _i6++) {
                  key = _Object$keys4[_i6];
                  payload[key] = data[key];
                }
              }
              if (payload.signature != null) {
                payload.signature = String(payload.signature);
              }
              _context9.n = 1;
              return this.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context9.v;
              newtx.msg = {
                module: this.name,
                request: 'flag tweet',
                data: payload
              };
              _iterator16 = _createForOfIteratorHelper(keys);
              try {
                for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                  _key4 = _step16.value;
                  if (_key4 && _key4 !== this.publicKey) {
                    newtx.addTo(_key4);
                  }
                }
              } catch (err) {
                _iterator16.e(err);
              } finally {
                _iterator16.f();
              }
              return _context9.a(2, newtx);
          }
        }, _callee9, this);
      }));
      function createFlagTweetTransaction() {
        return _createFlagTweetTransaction.apply(this, arguments);
      }
      return createFlagTweetTransaction;
    }()
  }, {
    key: "createReviewTweetTransaction",
    value: function () {
      var _createReviewTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var data,
          keys,
          payload,
          _i7,
          _Object$keys5,
          key,
          newtx,
          _iterator17,
          _step17,
          _key5,
          _args0 = arguments;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              data = _args0.length > 0 && _args0[0] !== undefined ? _args0[0] : {};
              keys = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : [];
              payload = {};
              if (data && _typeof(data) === 'object') {
                for (_i7 = 0, _Object$keys5 = Object.keys(data); _i7 < _Object$keys5.length; _i7++) {
                  key = _Object$keys5[_i7];
                  payload[key] = data[key];
                }
              }
              if (payload.signature != null) {
                payload.signature = String(payload.signature);
              }
              if (payload.decision != null) {
                payload.decision = String(payload.decision);
              }
              _context0.n = 1;
              return this.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context0.v;
              newtx.msg = {
                module: this.name,
                request: 'review tweet',
                data: payload
              };
              _iterator17 = _createForOfIteratorHelper(keys);
              try {
                for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                  _key5 = _step17.value;
                  if (_key5 && _key5 !== this.publicKey) {
                    newtx.addTo(_key5);
                  }
                }
              } catch (err) {
                _iterator17.e(err);
              } finally {
                _iterator17.f();
              }
              return _context0.a(2, newtx);
          }
        }, _callee0, this);
      }));
      function createReviewTweetTransaction() {
        return _createReviewTweetTransaction.apply(this, arguments);
      }
      return createReviewTweetTransaction;
    }()
  }, {
    key: "createEditTweetTransaction",
    value: function () {
      var _createEditTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var data,
          keys,
          payload,
          _i8,
          _Object$keys6,
          key,
          newtx,
          _iterator18,
          _step18,
          _key6,
          _args1 = arguments;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              data = _args1.length > 0 && _args1[0] !== undefined ? _args1[0] : {};
              keys = _args1.length > 1 && _args1[1] !== undefined ? _args1[1] : [];
              payload = {};
              if (data && _typeof(data) === 'object') {
                for (_i8 = 0, _Object$keys6 = Object.keys(data); _i8 < _Object$keys6.length; _i8++) {
                  key = _Object$keys6[_i8];
                  payload[key] = data[key];
                }
              }
              if (payload.text != null) {
                payload.text = String(payload.text);
              }
              if (payload.tweet_id != null) {
                payload.tweet_id = String(payload.tweet_id);
              }
              _context1.n = 1;
              return this.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context1.v;
              newtx.msg = {
                module: this.name,
                request: 'edit tweet',
                data: payload
              };
              _iterator18 = _createForOfIteratorHelper(keys);
              try {
                for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                  _key6 = _step18.value;
                  if (_key6 && _key6 !== this.publicKey) {
                    newtx.addTo(_key6);
                  }
                }
              } catch (err) {
                _iterator18.e(err);
              } finally {
                _iterator18.f();
              }
              return _context1.a(2, newtx);
          }
        }, _callee1, this);
      }));
      function createEditTweetTransaction() {
        return _createEditTweetTransaction.apply(this, arguments);
      }
      return createEditTweetTransaction;
    }()
  }, {
    key: "createDeleteTweetTransaction",
    value: function () {
      var _createDeleteTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var data,
          keys,
          payload,
          _i9,
          _Object$keys7,
          key,
          newtx,
          _iterator19,
          _step19,
          _key7,
          _args10 = arguments;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              data = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
              keys = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : [];
              payload = {};
              if (data && _typeof(data) === 'object') {
                for (_i9 = 0, _Object$keys7 = Object.keys(data); _i9 < _Object$keys7.length; _i9++) {
                  key = _Object$keys7[_i9];
                  payload[key] = data[key];
                }
              }
              if (payload.tweet_id != null) {
                payload.tweet_id = String(payload.tweet_id);
              }
              _context10.n = 1;
              return this.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context10.v;
              newtx.msg = {
                module: this.name,
                request: 'delete tweet',
                data: payload
              };
              _iterator19 = _createForOfIteratorHelper(keys);
              try {
                for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                  _key7 = _step19.value;
                  if (_key7 && _key7 !== this.publicKey) {
                    newtx.addTo(_key7);
                  }
                }
              } catch (err) {
                _iterator19.e(err);
              } finally {
                _iterator19.f();
              }
              return _context10.a(2, newtx);
          }
        }, _callee10, this);
      }));
      function createDeleteTweetTransaction() {
        return _createDeleteTweetTransaction.apply(this, arguments);
      }
      return createDeleteTweetTransaction;
    }()
  }, {
    key: "returnInteractionTargetPublicKey",
    value: function returnInteractionTargetPublicKey(tx) {
      var _tx$from, _tx$to;
      var actorPublicKey = (tx === null || tx === void 0 || (_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey) || '';
      // The wallet's sender output precedes recipients in tx.to.
      var target = tx === null || tx === void 0 || (_tx$to = tx.to) === null || _tx$to === void 0 ? void 0 : _tx$to.find(function (slip) {
        return (slip === null || slip === void 0 ? void 0 : slip.publicKey) && slip.publicKey !== actorPublicKey;
      });
      return (target === null || target === void 0 ? void 0 : target.publicKey) || '';
    }
  }, {
    key: "saveTweet",
    value: function () {
      var _saveTweet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(tweet) {
        var _tweet$tx,
          _this7 = this;
        var blk,
          signature,
          previousSave,
          archiveSave,
          _args11 = arguments;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              blk = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : null;
              if (!(tweet !== null && tweet !== void 0 && tweet.ephemeral)) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2);
            case 1:
              signature = tweet === null || tweet === void 0 || (_tweet$tx = tweet.tx) === null || _tweet$tx === void 0 ? void 0 : _tweet$tx.signature;
              if (!(!signature || !tweet.thread_id)) {
                _context11.n = 2;
                break;
              }
              return _context11.a(2);
            case 2:
              previousSave = this.tweet_archive_saves[signature] || Promise.resolve();
              archiveSave = previousSave["catch"](function () {}).then(function () {
                return _this7.saveTweetToArchive(tweet, blk);
              });
              this.tweet_archive_saves[signature] = archiveSave;
              _context11.p = 3;
              _context11.n = 4;
              return archiveSave;
            case 4:
              return _context11.a(2, _context11.v);
            case 5:
              _context11.p = 5;
              if (this.tweet_archive_saves[signature] === archiveSave) {
                delete this.tweet_archive_saves[signature];
              }
              return _context11.f(5);
            case 6:
              return _context11.a(2);
          }
        }, _callee11, this, [[3,, 5, 6]]);
      }));
      function saveTweet(_x6) {
        return _saveTweet.apply(this, arguments);
      }
      return saveTweet;
    }()
  }, {
    key: "saveTweetToArchive",
    value: function () {
      var _saveTweetToArchive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(tweet) {
        var _tweet$tx$optional;
        var blk,
          signature,
          archiveOptions,
          targetPublicKey,
          archivedTweets,
          result,
          savedTweets,
          _args12 = arguments;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              blk = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : null;
              signature = tweet.tx.signature;
              archiveOptions = {
                field1: 'RedSquare',
                preserve: 0,
                field4: tweet.parent_id || '',
                field5: tweet.thread_id,
                updated_at: Number((_tweet$tx$optional = tweet.tx.optional) === null || _tweet$tx$optional === void 0 ? void 0 : _tweet$tx$optional.updated_at) || Number(tweet.updated_at) || Number(tweet.tx.timestamp) || Date.now()
              };
              targetPublicKey = this.returnInteractionTargetPublicKey(tweet.tx);
              if (tweet.parent_id && targetPublicKey) {
                archiveOptions.field3 = targetPublicKey;
              }
              if (blk) {
                archiveOptions.block_hash = blk.hash;
                archiveOptions.block_id = Number(blk.id);
              }
              _context12.n = 1;
              return this.app.storage.loadTransactions({
                field1: 'RedSquare',
                sig: signature
              }, function (txs) {
                return txs || [];
              }, 'localhost');
            case 1:
              archivedTweets = _context12.v;
              if (!(archivedTweets !== null && archivedTweets !== void 0 && archivedTweets.length)) {
                _context12.n = 3;
                break;
              }
              _context12.n = 2;
              return this.app.storage.updateTransaction(tweet.tx, archiveOptions, 'localhost', 1);
            case 2:
              return _context12.a(2, false);
            case 3:
              _context12.n = 4;
              return this.app.storage.saveTransaction(tweet.tx, archiveOptions, 'localhost', blk);
            case 4:
              result = _context12.v;
              if (!(result !== null && result !== void 0 && result.err)) {
                _context12.n = 5;
                break;
              }
              return _context12.a(2, false);
            case 5:
              _context12.n = 6;
              return this.app.storage.loadTransactions({
                field1: 'RedSquare',
                sig: signature
              }, function (txs) {
                return txs || [];
              }, 'localhost');
            case 6:
              savedTweets = _context12.v;
              return _context12.a(2, Boolean(savedTweets === null || savedTweets === void 0 ? void 0 : savedTweets.length));
          }
        }, _callee12, this);
      }));
      function saveTweetToArchive(_x7) {
        return _saveTweetToArchive.apply(this, arguments);
      }
      return saveTweetToArchive;
    }()
  }, {
    key: "saveLike",
    value: function () {
      var _saveLike = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(tx) {
        var _this8 = this;
        var blk,
          signature,
          previousSave,
          archiveSave,
          _args13 = arguments;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              blk = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : null;
              signature = tx === null || tx === void 0 ? void 0 : tx.signature;
              if (signature) {
                _context13.n = 1;
                break;
              }
              return _context13.a(2, false);
            case 1:
              previousSave = this.like_archive_saves[signature] || Promise.resolve();
              archiveSave = previousSave["catch"](function () {}).then(function () {
                return _this8.saveLikeToArchive(tx, blk);
              });
              this.like_archive_saves[signature] = archiveSave;
              _context13.p = 2;
              _context13.n = 3;
              return archiveSave;
            case 3:
              return _context13.a(2, _context13.v);
            case 4:
              _context13.p = 4;
              if (this.like_archive_saves[signature] === archiveSave) {
                delete this.like_archive_saves[signature];
              }
              return _context13.f(4);
            case 5:
              return _context13.a(2);
          }
        }, _callee13, this, [[2,, 4, 5]]);
      }));
      function saveLike(_x8) {
        return _saveLike.apply(this, arguments);
      }
      return saveLike;
    }()
  }, {
    key: "saveLikeToArchive",
    value: function () {
      var _saveLikeToArchive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(tx) {
        var _tx$returnMessage, _txmsg$data2;
        var blk,
          txmsg,
          targetSignature,
          archiveOptions,
          archivedLikes,
          _args14 = arguments;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              blk = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : null;
              txmsg = (tx === null || tx === void 0 || (_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || (tx === null || tx === void 0 ? void 0 : tx.msg) || {};
              targetSignature = (txmsg === null || txmsg === void 0 || (_txmsg$data2 = txmsg.data) === null || _txmsg$data2 === void 0 ? void 0 : _txmsg$data2.signature) != null ? String(txmsg.data.signature) : '';
              archiveOptions = {
                field1: 'RedSquareLike',
                preserve: 0,
                field3: this.returnInteractionTargetPublicKey(tx),
                field4: targetSignature
              };
              if (blk) {
                archiveOptions.block_hash = blk.hash;
                archiveOptions.block_id = Number(blk.id);
              }
              _context14.n = 1;
              return this.app.storage.loadTransactions({
                field1: 'RedSquareLike',
                sig: tx.signature
              }, function (txs) {
                return txs || [];
              }, 'localhost');
            case 1:
              archivedLikes = _context14.v;
              if (!(archivedLikes !== null && archivedLikes !== void 0 && archivedLikes.length)) {
                _context14.n = 3;
                break;
              }
              _context14.n = 2;
              return this.app.storage.updateTransaction(tx, archiveOptions, 'localhost', 1);
            case 2:
              return _context14.a(2, false);
            case 3:
              _context14.n = 4;
              return this.app.storage.saveTransaction(tx, archiveOptions, 'localhost', blk);
            case 4:
              return _context14.a(2, true);
          }
        }, _callee14, this);
      }));
      function saveLikeToArchive(_x9) {
        return _saveLikeToArchive.apply(this, arguments);
      }
      return saveLikeToArchive;
    }()
  }, {
    key: "saveRetweet",
    value: function () {
      var _saveRetweet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(tx) {
        var _tx$returnMessage2,
          _txmsg$data3,
          _this9 = this;
        var blk,
          signature,
          txmsg,
          targetSignature,
          previousSave,
          archiveSave,
          _args16 = arguments;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.p = _context16.n) {
            case 0:
              blk = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : null;
              signature = tx === null || tx === void 0 ? void 0 : tx.signature;
              txmsg = (tx === null || tx === void 0 || (_tx$returnMessage2 = tx.returnMessage) === null || _tx$returnMessage2 === void 0 ? void 0 : _tx$returnMessage2.call(tx)) || (tx === null || tx === void 0 ? void 0 : tx.msg) || {};
              targetSignature = (txmsg === null || txmsg === void 0 || (_txmsg$data3 = txmsg.data) === null || _txmsg$data3 === void 0 ? void 0 : _txmsg$data3.signature) != null ? String(txmsg.data.signature) : '';
              if (!(!signature || !targetSignature)) {
                _context16.n = 1;
                break;
              }
              return _context16.a(2);
            case 1:
              previousSave = this.retweet_archive_saves[signature] || Promise.resolve();
              archiveSave = previousSave["catch"](function () {}).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
                var archiveOptions, archivedRetweets;
                return _regenerator().w(function (_context15) {
                  while (1) switch (_context15.n) {
                    case 0:
                      archiveOptions = {
                        field1: 'RedSquareRetweet',
                        preserve: 0,
                        field3: _this9.returnInteractionTargetPublicKey(tx),
                        field4: targetSignature
                      };
                      if (blk) {
                        archiveOptions.block_hash = blk.hash;
                        archiveOptions.block_id = Number(blk.id);
                      }
                      _context15.n = 1;
                      return _this9.app.storage.loadTransactions({
                        field1: 'RedSquareRetweet',
                        sig: signature
                      }, function (txs) {
                        return txs || [];
                      }, 'localhost');
                    case 1:
                      archivedRetweets = _context15.v;
                      if (!(archivedRetweets !== null && archivedRetweets !== void 0 && archivedRetweets.length)) {
                        _context15.n = 3;
                        break;
                      }
                      _context15.n = 2;
                      return _this9.app.storage.updateTransaction(tx, archiveOptions, 'localhost', 1);
                    case 2:
                      return _context15.a(2);
                    case 3:
                      _context15.n = 4;
                      return _this9.app.storage.saveTransaction(tx, archiveOptions, 'localhost', blk);
                    case 4:
                      return _context15.a(2);
                  }
                }, _callee15);
              })));
              this.retweet_archive_saves[signature] = archiveSave;
              _context16.p = 2;
              _context16.n = 3;
              return archiveSave;
            case 3:
              _context16.p = 3;
              if (this.retweet_archive_saves[signature] === archiveSave) {
                delete this.retweet_archive_saves[signature];
              }
              return _context16.f(3);
            case 4:
              return _context16.a(2);
          }
        }, _callee16, this, [[2,, 3, 4]]);
      }));
      function saveRetweet(_x0) {
        return _saveRetweet.apply(this, arguments);
      }
      return saveRetweet;
    }()
  }, {
    key: "receiveTweetTransaction",
    value: function () {
      var _receiveTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(tx) {
        var _this0 = this;
        var blk,
          tweet,
          inserted,
          createdAt,
          local,
          _this$manager3,
          _this$manager3$onTwee,
          parent,
          interactionTs,
          parentTx,
          parentTs,
          repliers,
          newReplier,
          _args17 = arguments;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              blk = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : null;
              tweet = this.addTweet(tx);
              if (!(tweet && !this.app.BROWSER)) {
                _context17.n = 1;
                break;
              }
              _context17.n = 1;
              return tweet.analyseTweetLinks(true);
            case 1:
              _context17.n = 2;
              return this.saveTweet(tweet, blk);
            case 2:
              inserted = _context17.v;
              Loader.noteLocalSyncedTweet(this, tweet === null || tweet === void 0 ? void 0 : tweet.created_at, blk);
              createdAt = Number(tweet === null || tweet === void 0 ? void 0 : tweet.created_at) || 0;
              if (this.app.BROWSER && inserted && blk && !(tweet !== null && tweet !== void 0 && tweet.parent_id) && !(tweet !== null && tweet !== void 0 && tweet.ephemeral) && createdAt > 0 && Date.now() - createdAt >= Loader.LIVE_TWEET_WINDOW_MS) {
                local = Loader.localPeer(this);
                if (local) {
                  Loader.reopenTweetSource(local);
                  (_this$manager3 = this.manager) === null || _this$manager3 === void 0 || (_this$manager3$onTwee = _this$manager3.onTweetHistoryAvailable) === null || _this$manager3$onTwee === void 0 || _this$manager3$onTwee.call(_this$manager3);
                }
              }
              if (this.app.BROWSER) {
                this.addNotification(tx);
              }
              if (!(tweet !== null && tweet !== void 0 && tweet.parent_id && tweet.parent_id !== tweet.signature)) {
                _context17.n = 5;
                break;
              }
              if (this.getTweet(tweet.parent_id)) {
                _context17.n = 3;
                break;
              }
              _context17.n = 3;
              return new Promise(function (resolve) {
                _this0.loadTransactions('tweets', 'all', function () {
                  return resolve();
                }, {
                  sig: tweet.parent_id
                });
              });
            case 3:
              parent = this.getTweet(tweet.parent_id);
              interactionTs = Number(tx.timestamp) || Date.now();
              if (!(parent !== null && parent !== void 0 && parent.tx)) {
                _context17.n = 5;
                break;
              }
              parentTx = parent.tx;
              if (!parentTx.optional || _typeof(parentTx.optional) !== 'object') {
                parentTx.optional = {};
              }
              parentTs = Number(parent.updated_at) || Number(parentTx.optional.updated_at) || Number(parentTx.timestamp) || 0;
              repliers = Array.isArray(parentTx.optional.repliers) ? parentTx.optional.repliers : [];
              newReplier = Boolean(tweet.publicKey && !repliers.includes(tweet.publicKey));
              if (newReplier) {
                repliers.push(tweet.publicKey);
              }
              parentTx.optional.repliers = repliers;
              parent.repliers = repliers.slice();
              if (interactionTs > parentTs) {
                parentTx.optional.num_replies = Number(parentTx.optional.num_replies) || 0;
                parentTx.optional.num_replies += 1;
                parent.replies = parentTx.optional.num_replies;
              }
              if (!(interactionTs > parentTs || newReplier)) {
                _context17.n = 5;
                break;
              }
              parent.updated_at = Math.max(parentTs + 1, interactionTs);
              parentTx.optional.updated_at = parent.updated_at;
              _context17.n = 4;
              return this.saveTweet(parent);
            case 4:
              parent.refreshControls();
            case 5:
              return _context17.a(2, tweet);
          }
        }, _callee17, this);
      }));
      function receiveTweetTransaction(_x1) {
        return _receiveTweetTransaction.apply(this, arguments);
      }
      return receiveTweetTransaction;
    }()
  }, {
    key: "receiveLikeTweetTransaction",
    value: function () {
      var _receiveLikeTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(tx) {
        var _tx$returnMessage3,
          _txmsg$data4,
          _this1 = this;
        var blk,
          txmsg,
          targetSignature,
          previousUpdate,
          targetUpdate,
          _args18 = arguments;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.p = _context18.n) {
            case 0:
              blk = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : null;
              txmsg = (tx === null || tx === void 0 || (_tx$returnMessage3 = tx.returnMessage) === null || _tx$returnMessage3 === void 0 ? void 0 : _tx$returnMessage3.call(tx)) || (tx === null || tx === void 0 ? void 0 : tx.msg) || {};
              targetSignature = (txmsg === null || txmsg === void 0 || (_txmsg$data4 = txmsg.data) === null || _txmsg$data4 === void 0 ? void 0 : _txmsg$data4.signature) != null ? String(txmsg.data.signature) : '';
              if (targetSignature) {
                _context18.n = 1;
                break;
              }
              return _context18.a(2, null);
            case 1:
              previousUpdate = this.like_target_updates[targetSignature] || Promise.resolve();
              targetUpdate = previousUpdate["catch"](function () {}).then(function () {
                return _this1.applyLikeTweetTransaction(tx, blk, targetSignature);
              });
              this.like_target_updates[targetSignature] = targetUpdate;
              _context18.p = 2;
              _context18.n = 3;
              return targetUpdate;
            case 3:
              return _context18.a(2, _context18.v);
            case 4:
              _context18.p = 4;
              if (this.like_target_updates[targetSignature] === targetUpdate) {
                delete this.like_target_updates[targetSignature];
              }
              return _context18.f(4);
            case 5:
              return _context18.a(2);
          }
        }, _callee18, this, [[2,, 4, 5]]);
      }));
      function receiveLikeTweetTransaction(_x10) {
        return _receiveLikeTweetTransaction.apply(this, arguments);
      }
      return receiveLikeTweetTransaction;
    }()
  }, {
    key: "applyLikeTweetTransaction",
    value: function () {
      var _applyLikeTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(tx, blk, targetSignature) {
        var _this10 = this;
        var isNewLike, interactionTs, likerKey, tweet, targetTx, targetTs, likers, updatedAt;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.n) {
            case 0:
              _context20.n = 1;
              return this.saveLike(tx, blk);
            case 1:
              isNewLike = _context20.v;
              interactionTs = Number(tx.timestamp) || Date.now();
              likerKey = tx.from && tx.from[0] && tx.from[0].publicKey ? String(tx.from[0].publicKey) : '';
              tweet = this.getTweet(targetSignature);
              if (!(tweet !== null && tweet !== void 0 && tweet.tx)) {
                _context20.n = 4;
                break;
              }
              targetTx = tweet.tx;
              if (!targetTx.optional || _typeof(targetTx.optional) !== 'object') {
                targetTx.optional = {};
              }
              targetTs = Number(tweet.updated_at) || Number(targetTx.optional.updated_at) || Number(targetTx.timestamp) || 0;
              likers = Array.isArray(targetTx.optional.likers) ? targetTx.optional.likers : [];
              if (!isNewLike) {
                _context20.n = 3;
                break;
              }
              targetTx.optional.num_likes = Number(targetTx.optional.num_likes) || 0;
              targetTx.optional.num_likes += 1;
              if (likerKey && !likers.includes(likerKey)) {
                likers.unshift(likerKey);
                targetTx.optional.likers = likers;
              }

              // Archive polling uses a strict updated_later_than cursor.
              updatedAt = Math.max(targetTs + 1, interactionTs);
              targetTx.optional.updated_at = updatedAt;
              tweet.likes = targetTx.optional.num_likes;
              tweet.likers = likers.slice();
              tweet.updated_at = updatedAt;

              // Peer-loaded tweets may not exist in the local archive yet.
              _context20.n = 2;
              return this.saveTweet(tweet);
            case 2:
              tweet.refreshControls();
            case 3:
              _context20.n = 5;
              break;
            case 4:
              _context20.n = 5;
              return new Promise(function (resolve) {
                _this10.app.storage.loadTransactions({
                  sig: targetSignature,
                  field1: 'RedSquare'
                }, /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(txs) {
                    var _targetTx, _targetTs, _likers, _updatedAt;
                    return _regenerator().w(function (_context19) {
                      while (1) switch (_context19.n) {
                        case 0:
                          if (!((txs === null || txs === void 0 ? void 0 : txs.length) > 0)) {
                            _context19.n = 1;
                            break;
                          }
                          _targetTx = txs[0];
                          if (!_targetTx.optional || _typeof(_targetTx.optional) !== 'object') {
                            _targetTx.optional = {};
                          }
                          _targetTs = Number(_targetTx.optional.updated_at) || Number(_targetTx.timestamp) || 0;
                          _likers = Array.isArray(_targetTx.optional.likers) ? _targetTx.optional.likers : [];
                          if (!isNewLike) {
                            _context19.n = 1;
                            break;
                          }
                          _targetTx.optional.num_likes = Number(_targetTx.optional.num_likes) || 0;
                          _targetTx.optional.num_likes += 1;
                          if (likerKey && !_likers.includes(likerKey)) {
                            _likers.unshift(likerKey);
                            _targetTx.optional.likers = _likers;
                          }
                          _updatedAt = Math.max(_targetTs + 1, interactionTs);
                          _context19.n = 1;
                          return _this10.app.storage.updateTransaction(_targetTx, {
                            updated_at: _updatedAt
                          }, 'localhost');
                        case 1:
                          resolve();
                        case 2:
                          return _context19.a(2);
                      }
                    }, _callee19);
                  }));
                  return function (_x14) {
                    return _ref3.apply(this, arguments);
                  };
                }(), 'localhost');
              });
            case 5:
              if (this.app.BROWSER) {
                this.addNotification(tx);
              }
              return _context20.a(2, tweet);
          }
        }, _callee20, this);
      }));
      function applyLikeTweetTransaction(_x11, _x12, _x13) {
        return _applyLikeTweetTransaction.apply(this, arguments);
      }
      return applyLikeTweetTransaction;
    }()
  }, {
    key: "receiveRetweetTransaction",
    value: function () {
      var _receiveRetweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(tx) {
        var _tx$returnMessage4,
          _txmsg$data5,
          _this11 = this;
        var blk,
          txmsg,
          targetSignature,
          interactionTs,
          retweeterKey,
          tweet,
          targetTx,
          targetTs,
          _args22 = arguments;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              blk = _args22.length > 1 && _args22[1] !== undefined ? _args22[1] : null;
              txmsg = (tx === null || tx === void 0 || (_tx$returnMessage4 = tx.returnMessage) === null || _tx$returnMessage4 === void 0 ? void 0 : _tx$returnMessage4.call(tx)) || (tx === null || tx === void 0 ? void 0 : tx.msg) || {};
              targetSignature = (txmsg === null || txmsg === void 0 || (_txmsg$data5 = txmsg.data) === null || _txmsg$data5 === void 0 ? void 0 : _txmsg$data5.signature) != null ? String(txmsg.data.signature) : '';
              if (targetSignature) {
                _context22.n = 1;
                break;
              }
              return _context22.a(2, null);
            case 1:
              _context22.n = 2;
              return this.saveRetweet(tx, blk);
            case 2:
              interactionTs = Number(tx.timestamp) || Date.now();
              retweeterKey = tx.from && tx.from[0] && tx.from[0].publicKey ? String(tx.from[0].publicKey) : '';
              tweet = this.getTweet(targetSignature);
              if (!(tweet !== null && tweet !== void 0 && tweet.tx)) {
                _context22.n = 5;
                break;
              }
              targetTx = tweet.tx;
              if (!targetTx.optional || _typeof(targetTx.optional) !== 'object') {
                targetTx.optional = {};
              }
              targetTs = Number(tweet.updated_at) || Number(targetTx.optional.updated_at) || Number(targetTx.timestamp) || 0;
              if (!(interactionTs > targetTs)) {
                _context22.n = 4;
                break;
              }
              targetTx.optional.num_retweets = Number(targetTx.optional.num_retweets) || 0;
              targetTx.optional.num_retweets += 1;
              if (!Array.isArray(targetTx.optional.retweeters)) {
                targetTx.optional.retweeters = [];
              }
              if (retweeterKey && !targetTx.optional.retweeters.includes(retweeterKey)) {
                targetTx.optional.retweeters.unshift(retweeterKey);
              }
              targetTx.optional.retweeted_at = interactionTs;
              targetTx.optional.updated_at = interactionTs;
              tweet.retweets = targetTx.optional.num_retweets;
              tweet.retweeters = targetTx.optional.retweeters.slice();
              tweet.updated_at = interactionTs;
              _context22.n = 3;
              return this.app.storage.updateTransaction(targetTx, {
                updated_at: interactionTs
              }, 'localhost');
            case 3:
              tweet.refreshControls();
            case 4:
              _context22.n = 6;
              break;
            case 5:
              _context22.n = 6;
              return new Promise(function (resolve) {
                _this11.app.storage.loadTransactions({
                  sig: targetSignature,
                  field1: 'RedSquare'
                }, /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(txs) {
                    var _targetTx2, _targetTs2;
                    return _regenerator().w(function (_context21) {
                      while (1) switch (_context21.n) {
                        case 0:
                          if (!((txs === null || txs === void 0 ? void 0 : txs.length) > 0)) {
                            _context21.n = 1;
                            break;
                          }
                          _targetTx2 = txs[0];
                          if (!_targetTx2.optional || _typeof(_targetTx2.optional) !== 'object') {
                            _targetTx2.optional = {};
                          }
                          _targetTs2 = Number(_targetTx2.optional.updated_at) || Number(_targetTx2.timestamp) || 0;
                          if (!(interactionTs > _targetTs2)) {
                            _context21.n = 1;
                            break;
                          }
                          _targetTx2.optional.num_retweets = Number(_targetTx2.optional.num_retweets) || 0;
                          _targetTx2.optional.num_retweets += 1;
                          if (!Array.isArray(_targetTx2.optional.retweeters)) {
                            _targetTx2.optional.retweeters = [];
                          }
                          if (retweeterKey && !_targetTx2.optional.retweeters.includes(retweeterKey)) {
                            _targetTx2.optional.retweeters.unshift(retweeterKey);
                          }
                          _targetTx2.optional.retweeted_at = interactionTs;
                          _context21.n = 1;
                          return _this11.app.storage.updateTransaction(_targetTx2, {
                            updated_at: interactionTs
                          }, 'localhost');
                        case 1:
                          resolve();
                        case 2:
                          return _context21.a(2);
                      }
                    }, _callee21);
                  }));
                  return function (_x16) {
                    return _ref4.apply(this, arguments);
                  };
                }(), 'localhost');
              });
            case 6:
              if (this.app.BROWSER) {
                this.addNotification(tx);
              }
              return _context22.a(2, tweet);
          }
        }, _callee22, this);
      }));
      function receiveRetweetTransaction(_x15) {
        return _receiveRetweetTransaction.apply(this, arguments);
      }
      return receiveRetweetTransaction;
    }()
  }, {
    key: "receiveFlagTweetTransaction",
    value: function () {
      var _receiveFlagTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(tx) {
        var _tx$returnMessage5,
          _txmsg$data6,
          _this12 = this;
        var blk,
          txmsg,
          targetSignature,
          interactionTs,
          tweet,
          _args24 = arguments;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.n) {
            case 0:
              blk = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : null;
              txmsg = (tx === null || tx === void 0 || (_tx$returnMessage5 = tx.returnMessage) === null || _tx$returnMessage5 === void 0 ? void 0 : _tx$returnMessage5.call(tx)) || (tx === null || tx === void 0 ? void 0 : tx.msg) || {};
              targetSignature = (txmsg === null || txmsg === void 0 || (_txmsg$data6 = txmsg.data) === null || _txmsg$data6 === void 0 ? void 0 : _txmsg$data6.signature) != null ? String(txmsg.data.signature) : '';
              if (targetSignature) {
                _context24.n = 1;
                break;
              }
              return _context24.a(2, null);
            case 1:
              interactionTs = Number(tx.timestamp) || Date.now();
              tweet = this.getTweet(targetSignature);
              if (!(tweet !== null && tweet !== void 0 && tweet.tx)) {
                _context24.n = 3;
                break;
              }
              if (!tweet.tx.optional || _typeof(tweet.tx.optional) !== 'object') {
                tweet.tx.optional = {};
              }
              tweet.tx.optional.flagged = 1;
              tweet.flagged = 1;
              _context24.n = 2;
              return this.app.storage.updateTransaction(tweet.tx, {
                updated_at: interactionTs,
                flagged: 1
              }, 'localhost');
            case 2:
              tweet.refresh();
              return _context24.a(2, tweet);
            case 3:
              _context24.n = 4;
              return new Promise(function (resolve) {
                _this12.app.storage.loadTransactions({
                  sig: targetSignature,
                  field1: 'RedSquare'
                }, /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(txs) {
                    var archivedTx;
                    return _regenerator().w(function (_context23) {
                      while (1) switch (_context23.n) {
                        case 0:
                          if (!((txs === null || txs === void 0 ? void 0 : txs.length) > 0)) {
                            _context23.n = 1;
                            break;
                          }
                          archivedTx = txs[0];
                          if (!archivedTx.optional || _typeof(archivedTx.optional) !== 'object') {
                            archivedTx.optional = {};
                          }
                          archivedTx.optional.flagged = 1;
                          _context23.n = 1;
                          return _this12.app.storage.updateTransaction(archivedTx, {
                            updated_at: interactionTs,
                            flagged: 1
                          }, 'localhost');
                        case 1:
                          resolve();
                        case 2:
                          return _context23.a(2);
                      }
                    }, _callee23);
                  }));
                  return function (_x18) {
                    return _ref5.apply(this, arguments);
                  };
                }(), 'localhost');
              });
            case 4:
              return _context24.a(2, null);
          }
        }, _callee24, this);
      }));
      function receiveFlagTweetTransaction(_x17) {
        return _receiveFlagTweetTransaction.apply(this, arguments);
      }
      return receiveFlagTweetTransaction;
    }()
  }, {
    key: "receiveEditTweetTransaction",
    value: function () {
      var _receiveEditTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(tx) {
        var _tx$returnMessage6,
          _txmsg$data7,
          _tx$from2,
          _this13 = this;
        var blk,
          txmsg,
          tweet_id,
          editorKey,
          interactionTs,
          tweet,
          applyToTx,
          _args27 = arguments;
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.n) {
            case 0:
              blk = _args27.length > 1 && _args27[1] !== undefined ? _args27[1] : null;
              txmsg = (tx === null || tx === void 0 || (_tx$returnMessage6 = tx.returnMessage) === null || _tx$returnMessage6 === void 0 ? void 0 : _tx$returnMessage6.call(tx)) || (tx === null || tx === void 0 ? void 0 : tx.msg) || {};
              tweet_id = (txmsg === null || txmsg === void 0 || (_txmsg$data7 = txmsg.data) === null || _txmsg$data7 === void 0 ? void 0 : _txmsg$data7.tweet_id) != null ? String(txmsg.data.tweet_id) : '';
              editorKey = (tx === null || tx === void 0 || (_tx$from2 = tx.from) === null || _tx$from2 === void 0 || (_tx$from2 = _tx$from2[0]) === null || _tx$from2 === void 0 ? void 0 : _tx$from2.publicKey) || '';
              if (tweet_id) {
                _context27.n = 1;
                break;
              }
              return _context27.a(2, null);
            case 1:
              interactionTs = Number(tx.timestamp) || Date.now();
              tweet = this.getTweet(tweet_id);
              applyToTx = /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(oldtx) {
                  var _oldtx$from;
                  return _regenerator().w(function (_context25) {
                    while (1) switch (_context25.n) {
                      case 0:
                        if (!(!oldtx || ((_oldtx$from = oldtx.from) === null || _oldtx$from === void 0 || (_oldtx$from = _oldtx$from[0]) === null || _oldtx$from === void 0 ? void 0 : _oldtx$from.publicKey) !== editorKey)) {
                          _context25.n = 1;
                          break;
                        }
                        return _context25.a(2, null);
                      case 1:
                        if (!oldtx.optional || _typeof(oldtx.optional) !== 'object') {
                          oldtx.optional = {};
                        }
                        if (!(interactionTs <= (Number(oldtx.optional.edit_ts) || 0))) {
                          _context25.n = 2;
                          break;
                        }
                        return _context25.a(2, oldtx);
                      case 2:
                        oldtx.optional.update_tx = tx.serialize_to_web(_this13.app);
                        oldtx.optional.edit_ts = interactionTs;
                        oldtx.optional.updated_at = interactionTs;
                        _context25.n = 3;
                        return _this13.app.storage.updateTransaction(oldtx, {
                          updated_at: interactionTs
                        }, 'localhost');
                      case 3:
                        return _context25.a(2, oldtx);
                    }
                  }, _callee25);
                }));
                return function applyToTx(_x20) {
                  return _ref6.apply(this, arguments);
                };
              }();
              if (!(tweet !== null && tweet !== void 0 && tweet.tx)) {
                _context27.n = 3;
                break;
              }
              _context27.n = 2;
              return applyToTx(tweet.tx);
            case 2:
              tweet.applyEditFromOptional();
              tweet.refresh();
              return _context27.a(2, tweet);
            case 3:
              _context27.n = 4;
              return new Promise(function (resolve) {
                _this13.app.storage.loadTransactions({
                  sig: tweet_id,
                  field1: 'RedSquare'
                }, /*#__PURE__*/function () {
                  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(txs) {
                    return _regenerator().w(function (_context26) {
                      while (1) switch (_context26.n) {
                        case 0:
                          if (!(txs !== null && txs !== void 0 && txs.length)) {
                            _context26.n = 1;
                            break;
                          }
                          _context26.n = 1;
                          return applyToTx(txs[0]);
                        case 1:
                          resolve();
                        case 2:
                          return _context26.a(2);
                      }
                    }, _callee26);
                  }));
                  return function (_x21) {
                    return _ref7.apply(this, arguments);
                  };
                }(), 'localhost');
              });
            case 4:
              return _context27.a(2, null);
          }
        }, _callee27, this);
      }));
      function receiveEditTweetTransaction(_x19) {
        return _receiveEditTweetTransaction.apply(this, arguments);
      }
      return receiveEditTweetTransaction;
    }()
  }, {
    key: "receiveDeleteTweetTransaction",
    value: function () {
      var _receiveDeleteTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31(tx) {
        var _tx$returnMessage7,
          _txmsg$data8,
          _tx$from3,
          _tweet$embedded,
          _this14 = this;
        var blk,
          txmsg,
          tweet_id,
          deleterKey,
          interactionTs,
          tweet,
          parent_id,
          retweet_of,
          _this$manager4,
          _this$manager4$onTwee,
          _args31 = arguments;
        return _regenerator().w(function (_context31) {
          while (1) switch (_context31.n) {
            case 0:
              blk = _args31.length > 1 && _args31[1] !== undefined ? _args31[1] : null;
              txmsg = (tx === null || tx === void 0 || (_tx$returnMessage7 = tx.returnMessage) === null || _tx$returnMessage7 === void 0 ? void 0 : _tx$returnMessage7.call(tx)) || (tx === null || tx === void 0 ? void 0 : tx.msg) || {};
              tweet_id = (txmsg === null || txmsg === void 0 || (_txmsg$data8 = txmsg.data) === null || _txmsg$data8 === void 0 ? void 0 : _txmsg$data8.tweet_id) != null ? String(txmsg.data.tweet_id) : '';
              deleterKey = (tx === null || tx === void 0 || (_tx$from3 = tx.from) === null || _tx$from3 === void 0 || (_tx$from3 = _tx$from3[0]) === null || _tx$from3 === void 0 ? void 0 : _tx$from3.publicKey) || '';
              if (tweet_id) {
                _context31.n = 1;
                break;
              }
              return _context31.a(2, null);
            case 1:
              interactionTs = Number(tx.timestamp) || Date.now();
              tweet = this.getTweet(tweet_id);
              parent_id = (tweet === null || tweet === void 0 ? void 0 : tweet.parent_id) || '';
              retweet_of = (tweet === null || tweet === void 0 || (_tweet$embedded = tweet.embedded) === null || _tweet$embedded === void 0 ? void 0 : _tweet$embedded.signature) || '';
              if (tweet) {
                tweet.removeFromDom();
                this.removeTweet(tweet_id);
                (_this$manager4 = this.manager) === null || _this$manager4 === void 0 || (_this$manager4$onTwee = _this$manager4.onTweetDeleted) === null || _this$manager4$onTwee === void 0 || _this$manager4$onTwee.call(_this$manager4, tweet_id);
              }
              _context31.n = 2;
              return new Promise(function (resolve) {
                _this14.app.storage.loadTransactions({
                  sig: tweet_id,
                  field1: 'RedSquare'
                }, /*#__PURE__*/function () {
                  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(txs) {
                    var _oldtx$from2, oldtx, _oldtx$msg, _oldtx$returnMessage, archivedParent, archivedRetweetOf, _msg$data, msg, embedded;
                    return _regenerator().w(function (_context30) {
                      while (1) switch (_context30.n) {
                        case 0:
                          if (!(txs !== null && txs !== void 0 && txs.length)) {
                            _context30.n = 3;
                            break;
                          }
                          oldtx = txs[0];
                          if (!(((_oldtx$from2 = oldtx.from) === null || _oldtx$from2 === void 0 || (_oldtx$from2 = _oldtx$from2[0]) === null || _oldtx$from2 === void 0 ? void 0 : _oldtx$from2.publicKey) === deleterKey)) {
                            _context30.n = 3;
                            break;
                          }
                          archivedParent = parent_id || (((_oldtx$msg = oldtx.msg) === null || _oldtx$msg === void 0 || (_oldtx$msg = _oldtx$msg.data) === null || _oldtx$msg === void 0 ? void 0 : _oldtx$msg.parent_id) != null ? String(oldtx.msg.data.parent_id) : '') || (typeof oldtx.returnMessage === 'function' ? String(((_oldtx$returnMessage = oldtx.returnMessage()) === null || _oldtx$returnMessage === void 0 || (_oldtx$returnMessage = _oldtx$returnMessage.data) === null || _oldtx$returnMessage === void 0 ? void 0 : _oldtx$returnMessage.parent_id) || '') : '');
                          archivedRetweetOf = retweet_of;
                          if (!archivedRetweetOf) {
                            msg = typeof oldtx.returnMessage === 'function' ? oldtx.returnMessage() : oldtx.msg;
                            embedded = msg === null || msg === void 0 || (_msg$data = msg.data) === null || _msg$data === void 0 ? void 0 : _msg$data.embedded;
                            if (embedded !== null && embedded !== void 0 && embedded.signature) {
                              archivedRetweetOf = String(embedded.signature);
                            }
                          }
                          _context30.n = 1;
                          return _this14.app.storage.deleteTransaction(oldtx, {}, 'localhost');
                        case 1:
                          if (!archivedParent) {
                            _context30.n = 2;
                            break;
                          }
                          _context30.n = 2;
                          return new Promise(function (r2) {
                            _this14.app.storage.loadTransactions({
                              sig: archivedParent,
                              field1: 'RedSquare'
                            }, /*#__PURE__*/function () {
                              var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(parentTxs) {
                                var _parentTxs$;
                                var parent, _parent$refreshContro;
                                return _regenerator().w(function (_context28) {
                                  while (1) switch (_context28.n) {
                                    case 0:
                                      if (!(parentTxs !== null && parentTxs !== void 0 && (_parentTxs$ = parentTxs[0]) !== null && _parentTxs$ !== void 0 && (_parentTxs$ = _parentTxs$.optional) !== null && _parentTxs$ !== void 0 && _parentTxs$.num_replies)) {
                                        _context28.n = 2;
                                        break;
                                      }
                                      parentTxs[0].optional.num_replies--;
                                      _context28.n = 1;
                                      return _this14.app.storage.updateTransaction(parentTxs[0], {
                                        updated_at: interactionTs
                                      }, 'localhost');
                                    case 1:
                                      parent = _this14.getTweet(archivedParent);
                                      if (parent) {
                                        parent.replies = parentTxs[0].optional.num_replies;
                                        (_parent$refreshContro = parent.refreshControls) === null || _parent$refreshContro === void 0 || _parent$refreshContro.call(parent);
                                      }
                                    case 2:
                                      r2();
                                    case 3:
                                      return _context28.a(2);
                                  }
                                }, _callee28);
                              }));
                              return function (_x24) {
                                return _ref9.apply(this, arguments);
                              };
                            }(), 'localhost');
                          });
                        case 2:
                          if (!archivedRetweetOf) {
                            _context30.n = 3;
                            break;
                          }
                          _context30.n = 3;
                          return new Promise(function (r2) {
                            _this14.app.storage.loadTransactions({
                              sig: archivedRetweetOf,
                              field1: 'RedSquare'
                            }, /*#__PURE__*/function () {
                              var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(sourceTxs) {
                                var _sourceTxs$;
                                var source, _source$refreshContro;
                                return _regenerator().w(function (_context29) {
                                  while (1) switch (_context29.n) {
                                    case 0:
                                      if (!(sourceTxs !== null && sourceTxs !== void 0 && (_sourceTxs$ = sourceTxs[0]) !== null && _sourceTxs$ !== void 0 && (_sourceTxs$ = _sourceTxs$.optional) !== null && _sourceTxs$ !== void 0 && _sourceTxs$.num_retweets)) {
                                        _context29.n = 2;
                                        break;
                                      }
                                      sourceTxs[0].optional.num_retweets--;
                                      _context29.n = 1;
                                      return _this14.app.storage.updateTransaction(sourceTxs[0], {
                                        updated_at: interactionTs
                                      }, 'localhost');
                                    case 1:
                                      source = _this14.getTweet(archivedRetweetOf);
                                      if (source) {
                                        source.retweets = sourceTxs[0].optional.num_retweets;
                                        (_source$refreshContro = source.refreshControls) === null || _source$refreshContro === void 0 || _source$refreshContro.call(source);
                                      }
                                    case 2:
                                      r2();
                                    case 3:
                                      return _context29.a(2);
                                  }
                                }, _callee29);
                              }));
                              return function (_x25) {
                                return _ref0.apply(this, arguments);
                              };
                            }(), 'localhost');
                          });
                        case 3:
                          resolve();
                        case 4:
                          return _context30.a(2);
                      }
                    }, _callee30);
                  }));
                  return function (_x23) {
                    return _ref8.apply(this, arguments);
                  };
                }(), 'localhost');
              });
            case 2:
              if (this.app.BROWSER) {
                _context31.n = 3;
                break;
              }
              _context31.n = 3;
              return this.app.storage.saveTransaction(tx, {
                field1: 'RedSquare'
              }, 'localhost', blk);
            case 3:
              return _context31.a(2, true);
          }
        }, _callee31, this);
      }));
      function receiveDeleteTweetTransaction(_x22) {
        return _receiveDeleteTweetTransaction.apply(this, arguments);
      }
      return receiveDeleteTweetTransaction;
    }()
  }, {
    key: "receiveReviewTweetTransaction",
    value: function () {
      var _receiveReviewTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33(tx) {
        var _tx$returnMessage8,
          _txmsg$data9,
          _txmsg$data0,
          _this15 = this;
        var blk,
          txmsg,
          targetSignature,
          decision,
          interactionTs,
          tweet,
          resolveTargetTx,
          targetTx,
          _this$moderate,
          _this$moderate$remove,
          _this$moderate2,
          _this$moderate2$remov,
          _this$moderate3,
          _this$moderate3$remov,
          _args33 = arguments;
        return _regenerator().w(function (_context33) {
          while (1) switch (_context33.n) {
            case 0:
              blk = _args33.length > 1 && _args33[1] !== undefined ? _args33[1] : null;
              txmsg = (tx === null || tx === void 0 || (_tx$returnMessage8 = tx.returnMessage) === null || _tx$returnMessage8 === void 0 ? void 0 : _tx$returnMessage8.call(tx)) || (tx === null || tx === void 0 ? void 0 : tx.msg) || {};
              targetSignature = (txmsg === null || txmsg === void 0 || (_txmsg$data9 = txmsg.data) === null || _txmsg$data9 === void 0 ? void 0 : _txmsg$data9.signature) != null ? String(txmsg.data.signature) : '';
              decision = (txmsg === null || txmsg === void 0 || (_txmsg$data0 = txmsg.data) === null || _txmsg$data0 === void 0 ? void 0 : _txmsg$data0.decision) != null ? String(txmsg.data.decision) : '';
              if (!(!targetSignature || decision !== 'approve' && decision !== 'delete')) {
                _context33.n = 1;
                break;
              }
              return _context33.a(2, null);
            case 1:
              interactionTs = Number(tx.timestamp) || Date.now();
              tweet = this.getTweet(targetSignature);
              resolveTargetTx = /*#__PURE__*/function () {
                var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32() {
                  return _regenerator().w(function (_context32) {
                    while (1) switch (_context32.n) {
                      case 0:
                        if (!(tweet !== null && tweet !== void 0 && tweet.tx)) {
                          _context32.n = 1;
                          break;
                        }
                        return _context32.a(2, tweet.tx);
                      case 1:
                        _context32.n = 2;
                        return new Promise(function (resolve) {
                          _this15.app.storage.loadTransactions({
                            sig: targetSignature,
                            field1: 'RedSquare'
                          }, function (txs) {
                            resolve(txs !== null && txs !== void 0 && txs.length ? txs[0] : null);
                          }, 'localhost');
                        });
                      case 2:
                        return _context32.a(2, _context32.v);
                    }
                  }, _callee32);
                }));
                return function resolveTargetTx() {
                  return _ref1.apply(this, arguments);
                };
              }();
              _context33.n = 2;
              return resolveTargetTx();
            case 2:
              targetTx = _context33.v;
              if (targetTx) {
                _context33.n = 3;
                break;
              }
              if (this.app.BROWSER && this.moderator_mode) {
                (_this$moderate = this.moderate) === null || _this$moderate === void 0 || (_this$moderate$remove = _this$moderate.removeTweet) === null || _this$moderate$remove === void 0 || _this$moderate$remove.call(_this$moderate, targetSignature);
              }
              return _context33.a(2, null);
            case 3:
              if (!(decision === 'delete')) {
                _context33.n = 5;
                break;
              }
              _context33.n = 4;
              return this.app.storage.deleteTransaction(targetTx, null, 'localhost');
            case 4:
              this.removeTweet(targetSignature);
              if (this.app.BROWSER && this.moderator_mode) {
                (_this$moderate2 = this.moderate) === null || _this$moderate2 === void 0 || (_this$moderate2$remov = _this$moderate2.removeTweet) === null || _this$moderate2$remov === void 0 || _this$moderate2$remov.call(_this$moderate2, targetSignature);
              }
              return _context33.a(2, null);
            case 5:
              // approve → flagged = 2 (reviewed)
              if (!targetTx.optional || _typeof(targetTx.optional) !== 'object') {
                targetTx.optional = {};
              }
              targetTx.optional.flagged = 2;
              _context33.n = 6;
              return this.app.storage.updateTransaction(targetTx, {
                updated_at: interactionTs,
                flagged: 2
              }, 'localhost');
            case 6:
              if (tweet) {
                tweet.flagged = 2;
              }
              if (this.app.BROWSER && this.moderator_mode) {
                (_this$moderate3 = this.moderate) === null || _this$moderate3 === void 0 || (_this$moderate3$remov = _this$moderate3.removeTweet) === null || _this$moderate3$remov === void 0 || _this$moderate3$remov.call(_this$moderate3, targetSignature);
              }
              return _context33.a(2, tweet || null);
          }
        }, _callee33, this);
      }));
      function receiveReviewTweetTransaction(_x26) {
        return _receiveReviewTweetTransaction.apply(this, arguments);
      }
      return receiveReviewTweetTransaction;
    }()
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee34(blk, tx, conf) {
        var txmsg, signature, hadTweet, tweet, _this$manager5, _this$manager5$onNewe, _t4;
        return _regenerator().w(function (_context34) {
          while (1) switch (_context34.n) {
            case 0:
              if (!(Number(conf) !== 0)) {
                _context34.n = 1;
                break;
              }
              return _context34.a(2);
            case 1:
              txmsg = tx.returnMessage();
              if (!(txmsg.module && txmsg.module !== this.name)) {
                _context34.n = 2;
                break;
              }
              return _context34.a(2);
            case 2:
              _t4 = txmsg.request;
              _context34.n = _t4 === 'create tweet' ? 3 : _t4 === 'like tweet' ? 5 : _t4 === 'retweet' ? 7 : _t4 === 'flag tweet' ? 9 : _t4 === 'review tweet' ? 11 : _t4 === 'edit tweet' ? 13 : _t4 === 'delete tweet' ? 15 : 17;
              break;
            case 3:
              signature = tx.signature != null ? String(tx.signature) : '';
              hadTweet = this.hasTweet(signature);
              _context34.n = 4;
              return this.receiveTweetTransaction(tx, blk);
            case 4:
              tweet = _context34.v;
              if (this.app.BROWSER && tweet && !hadTweet) {
                (_this$manager5 = this.manager) === null || _this$manager5 === void 0 || (_this$manager5$onNewe = _this$manager5.onNewerContentLoaded) === null || _this$manager5$onNewe === void 0 || _this$manager5$onNewe.call(_this$manager5, {
                  type: 'tweets',
                  direction: 'newer',
                  added: [signature],
                  new_tweets: [signature],
                  updated: [],
                  ignored: [],
                  exhausted: false
                }, {
                  announce: true
                });
              }
              return _context34.a(3, 18);
            case 5:
              _context34.n = 6;
              return this.receiveLikeTweetTransaction(tx, blk);
            case 6:
              return _context34.a(3, 18);
            case 7:
              _context34.n = 8;
              return this.receiveRetweetTransaction(tx, blk);
            case 8:
              return _context34.a(3, 18);
            case 9:
              _context34.n = 10;
              return this.receiveFlagTweetTransaction(tx, blk);
            case 10:
              return _context34.a(3, 18);
            case 11:
              _context34.n = 12;
              return this.receiveReviewTweetTransaction(tx, blk);
            case 12:
              return _context34.a(3, 18);
            case 13:
              _context34.n = 14;
              return this.receiveEditTweetTransaction(tx, blk);
            case 14:
              return _context34.a(3, 18);
            case 15:
              _context34.n = 16;
              return this.receiveDeleteTweetTransaction(tx, blk);
            case 16:
              return _context34.a(3, 18);
            case 17:
              return _context34.a(3, 18);
            case 18:
              return _context34.a(2);
          }
        }, _callee34, this);
      }));
      function onConfirmation(_x27, _x28, _x29) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "respondTo",
    value: function respondTo() {
      var _this16 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      if (type === 'redsquare-api') {
        return this.redsquare_api;
      }
      if (type === 'user-menu') {
        var publicKey = (obj === null || obj === void 0 ? void 0 : obj.publicKey) || '';
        if (!publicKey) {
          return null;
        }
        return {
          text: publicKey === this.publicKey ? 'My Tweets' : 'View Tweets',
          icon: 'fa-solid fa-square',
          image: '/saito/icons/saito-redsquare-icon-solid.svg',
          callback: function callback() {
            if (_this16.browser_active && _this16.manager) {
              _this16.manager.renderPosts(publicKey);
              return;
            }
            navigateWindow("/".concat(encodeURI(_this16.returnSlug()), "/user/").concat(encodeURIComponent(publicKey)));
          }
        };
      }
      if (type === 'saito-header') {
        if (this.browser_active) {
          return [];
        }
        return [{
          text: 'RedSquare',
          icon: 'fa-solid fa-square',
          rank: 20,
          type: 'navigation',
          navigation: '/redsquare',
          callback: function callback() {
            navigateWindow('/redsquare');
          },
          event: function event(id) {
            _this16.app.connection.on('redsquare-update-notifications', function (unread) {
              _this16.app.browser.addNotificationToId(unread, id);
              _this16.app.connection.emit('saito-header-notification', 'redsquare', unread);
            });
          }
        }];
      }
      if (type === 'saito-floating-menu') {
        return [{
          text: 'Tweet',
          icon: 'fa-solid fa-pen',
          is_active: this.browser_active,
          disallowed_mods: ['arcade'],
          rank: 10,
          callback: function callback(app) {
            var _this16$compose_overl;
            (_this16$compose_overl = _this16.compose_overlay) === null || _this16$compose_overl === void 0 || _this16$compose_overl.open();
          }
        }, {
          text: 'Tweet Image',
          icon: 'fas fa-image',
          is_active: this.browser_active,
          disallowed_mods: ['arcade'],
          rank: 20,
          callback: function callback(app) {
            var _this16$compose_overl2;
            (_this16$compose_overl2 = _this16.compose_overlay) === null || _this16$compose_overl2 === void 0 || _this16$compose_overl2.open();
            setTimeout(function () {
              var _document$querySelect;
              (_document$querySelect = document.querySelector('.saito-overlay .compose .file-input')) === null || _document$querySelect === void 0 || _document$querySelect.click();
            }, 100);
          }
        }];
      }
      return null;
    }

    //
    // Tweet API — delegated to lib/tweets.js
    //
  }, {
    key: "addTweet",
    value: function addTweet(tx) {
      return Tweets.addTweet(this, tx);
    }
  }, {
    key: "removeTweet",
    value: function removeTweet(signature) {
      return Tweets.removeTweet(this, signature);
    }
  }, {
    key: "updateTweet",
    value: function updateTweet(tx) {
      return Tweets.updateTweet(this, tx);
    }
  }, {
    key: "getTweet",
    value: function getTweet(signature) {
      return Tweets.getTweet(this, signature) || this.profile_tweets[String(signature || '')] || null;
    }
  }, {
    key: "showTweetInfo",
    value: function showTweetInfo(tweet) {
      return Tweets.showTweetInfo(this, tweet);
    }
  }, {
    key: "hasTweet",
    value: function hasTweet(signature) {
      return Tweets.hasTweet(this, signature);
    }
  }, {
    key: "isValidTweetMessage",
    value: function isValidTweetMessage(tweet) {
      return Tweets.isValidTweetMessage(this, tweet);
    }
  }, {
    key: "indexTweetRelationships",
    value: function indexTweetRelationships(signature) {
      return Tweets.indexTweetRelationships(this, signature);
    }
  }, {
    key: "unindexTweetRelationships",
    value: function unindexTweetRelationships(signature) {
      return Tweets.unindexTweetRelationships(this, signature);
    }
  }, {
    key: "addChildSignature",
    value: function addChildSignature(parentSignature, childSignature) {
      return Tweets.addChildSignature(this, parentSignature, childSignature);
    }
  }, {
    key: "removeChildSignature",
    value: function removeChildSignature(parentSignature, childSignature) {
      return Tweets.removeChildSignature(this, parentSignature, childSignature);
    }
  }, {
    key: "updateCriticalChild",
    value: function updateCriticalChild(parentSignature) {
      return Tweets.updateCriticalChild(this, parentSignature);
    }
  }, {
    key: "attachOrphans",
    value: function attachOrphans(parentSignature) {
      return Tweets.attachOrphans(this, parentSignature);
    }
  }, {
    key: "insertTimeline",
    value: function insertTimeline(signature) {
      return Tweets.insertTimeline(this, signature);
    }
  }, {
    key: "removeFromTimeline",
    value: function removeFromTimeline(signature) {
      return Tweets.removeFromTimeline(this, signature);
    }
  }, {
    key: "resortTimeline",
    value: function resortTimeline() {
      return Tweets.resortTimeline(this);
    }

    //
    // Notification API — delegated to lib/notifications.js
    //
  }, {
    key: "normalizeNotificationInput",
    value: function normalizeNotificationInput(input) {
      return Notifications.normalizeNotificationInput(this, input);
    }
  }, {
    key: "getNotificationAggregateKey",
    value: function getNotificationAggregateKey(notification) {
      return Notifications.getNotificationAggregateKey(this, notification);
    }
  }, {
    key: "getUnreadNotificationCount",
    value: function getUnreadNotificationCount() {
      return Notifications.getUnreadNotificationCount(this);
    }
  }, {
    key: "markNotificationsViewed",
    value: function markNotificationsViewed() {
      return Notifications.markNotificationsViewed(this);
    }
  }, {
    key: "updateNotificationBadge",
    value: function updateNotificationBadge() {
      return Notifications.updateNotificationBadge(this);
    }
  }, {
    key: "ensureNotificationTweet",
    value: function ensureNotificationTweet(notification) {
      return Notifications.ensureNotificationTweet(this, notification);
    }
  }, {
    key: "addNotification",
    value: function addNotification(input) {
      return Notifications.addNotification(this, input);
    }
  }, {
    key: "removeNotification",
    value: function removeNotification(signature) {
      return Notifications.removeNotification(this, signature);
    }
  }, {
    key: "updateNotification",
    value: function updateNotification(input) {
      return Notifications.updateNotification(this, input);
    }
  }, {
    key: "getNotification",
    value: function getNotification(signature) {
      return Notifications.getNotification(this, signature);
    }
  }, {
    key: "hasNotification",
    value: function hasNotification(signature) {
      return Notifications.hasNotification(this, signature);
    }
  }, {
    key: "insertNotificationTimeline",
    value: function insertNotificationTimeline(signature) {
      return Notifications.insertNotificationTimeline(this, signature);
    }
  }, {
    key: "removeFromNotificationTimeline",
    value: function removeFromNotificationTimeline(signature) {
      return Notifications.removeFromNotificationTimeline(this, signature);
    }
  }, {
    key: "resortNotificationTimeline",
    value: function resortNotificationTimeline() {
      return Notifications.resortNotificationTimeline(this);
    }
  }, {
    key: "ensureRendered",
    value: function () {
      var _ensureRendered = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee35() {
        var _this$main;
        return _regenerator().w(function (_context35) {
          while (1) switch (_context35.n) {
            case 0:
              if (this.browser_active) {
                _context35.n = 1;
                break;
              }
              return _context35.a(2);
            case 1:
              if (!(this.main == null)) {
                _context35.n = 2;
                break;
              }
              _context35.n = 2;
              return this.render();
            case 2:
              if ((_this$main = this.main) !== null && _this$main !== void 0 && _this$main.manager) {
                this.main.manager.render();
              }
            case 3:
              return _context35.a(2);
          }
        }, _callee35, this);
      }));
      function ensureRendered() {
        return _ensureRendered.apply(this, arguments);
      }
      return ensureRendered;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee36() {
        var _this$manager6, _this$manager6$applyL, _this$app$modules3;
        var _this$app$modules$ret, _this$app$modules2, cm;
        return _regenerator().w(function (_context36) {
          while (1) switch (_context36.n) {
            case 0:
              if (!(!this.app.BROWSER || !this.browser_active)) {
                _context36.n = 1;
                break;
              }
              return _context36.a(2);
            case 1:
              if (!(this.main == null)) {
                _context36.n = 3;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              _context36.n = 2;
              return this.header.initialize(this.app);
            case 2:
              this.main = new Main(this.app, this);
              this.addComponent(this.header);
              this.addComponent(this.main);

              // Chat remains optional and owns its UI; RedSquare only supplies containers.
              cm = ((_this$app$modules$ret = (_this$app$modules2 = this.app.modules).returnFirstRespondTo) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.call(_this$app$modules2, 'chat-manager')) || null;
              this.main.setChatManager(cm);
              if (this.main.hasChatCapability()) {
                this.addComponent(cm);
              }
            case 3:
              _context36.n = 4;
              return _superPropGet(RedSquare, "render", this, 3)([]);
            case 4:
              _context36.n = 5;
              return (_this$manager6 = this.manager) === null || _this$manager6 === void 0 || (_this$manager6$applyL = _this$manager6.applyLocationRoute) === null || _this$manager6$applyL === void 0 ? void 0 : _this$manager6$applyL.call(_this$manager6);
            case 5:
              if (!((_this$app$modules3 = this.app.modules) !== null && _this$app$modules3 !== void 0 && _this$app$modules3.renderInto)) {
                _context36.n = 8;
                break;
              }
              _context36.n = 6;
              return this.app.modules.renderInto('.redsquare-arcade');
            case 6:
              _context36.n = 7;
              return this.app.modules.renderInto('.redsquare-leaderboard');
            case 7:
              _context36.n = 8;
              return this.app.modules.renderInto('.redsquare-sidebar');
            case 8:
              this.renderFirstVisitSplash();
            case 9:
              return _context36.a(2);
          }
        }, _callee36, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "renderFirstVisitSplash",
    value: function renderFirstVisitSplash() {
      var _document$querySelect2,
        _this17 = this;
      if (!this.app.BROWSER || !this.show_splash || document.querySelector('.redsquare-splash-overlay')) {
        return;
      }
      document.body.insertAdjacentHTML('beforeend', SplashTemplate());

      // Persist dismissal only when the user completes onboarding — not when the
      // splash is merely shown. Otherwise a reload mid-splash permanently skips it.
      (_document$querySelect2 = document.querySelector('.redsquare-splash-join')) === null || _document$querySelect2 === void 0 || _document$querySelect2.addEventListener('click', function () {
        var _document$querySelect3;
        (_document$querySelect3 = document.querySelector('.redsquare-splash-overlay')) === null || _document$querySelect3 === void 0 || _document$querySelect3.remove();
        _this17.show_splash = false;
        _this17.saveOptions();
      });
    }
  }, {
    key: "returnTweetUrl",
    value: function returnTweetUrl(signature) {
      if (typeof window === 'undefined') {
        return '';
      }
      return "".concat(window.location.origin, "/").concat(encodeURI(this.returnSlug()), "/tweet/").concat(encodeURIComponent(signature));
    }
  }, {
    key: "returnUserUrl",
    value: function returnUserUrl(publicKey) {
      var path = "/".concat(encodeURI(this.returnSlug()), "/user/").concat(encodeURIComponent(publicKey || ''));
      if (typeof window === 'undefined') {
        return path;
      }
      return "".concat(window.location.origin).concat(path);
    }
  }, {
    key: "returnUserPublicKeyFromLocation",
    value: function returnUserPublicKeyFromLocation() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var currentLocation = location || (typeof window !== 'undefined' ? window.location : null);
      if (!currentLocation) {
        return '';
      }
      var prefix = "/".concat(encodeURI(this.returnSlug()), "/user/");
      var pathname = currentLocation.pathname || '';
      if (pathname.startsWith(prefix)) {
        var encodedPublicKey = pathname.slice(prefix.length).split('/')[0];
        try {
          return decodeURIComponent(encodedPublicKey);
        } catch (err) {
          return '';
        }
      }
      var params = new URLSearchParams(currentLocation.search || '');
      var legacyPublicKey = params.get('user_id') || '';
      if (legacyPublicKey) {
        return legacyPublicKey;
      }
      return currentLocation.hash === '#profile' ? this.publicKey || '' : '';
    }
  }, {
    key: "cacheProfileTweetTransactions",
    value: function () {
      var _cacheProfileTweetTransactions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee37() {
        var txs,
          cached,
          _iterator20,
          _step20,
          _tx$returnMessage9,
          _this$app$modules4,
          _this$app$modules4$mo,
          tx,
          message,
          signature,
          tweet,
          _args37 = arguments,
          _t5;
        return _regenerator().w(function (_context37) {
          while (1) switch (_context37.p = _context37.n) {
            case 0:
              txs = _args37.length > 0 && _args37[0] !== undefined ? _args37[0] : [];
              cached = [];
              _iterator20 = _createForOfIteratorHelper(txs);
              _context37.p = 1;
              _iterator20.s();
            case 2:
              if ((_step20 = _iterator20.n()).done) {
                _context37.n = 7;
                break;
              }
              tx = _step20.value;
              if (tx) {
                _context37.n = 3;
                break;
              }
              return _context37.a(3, 6);
            case 3:
              if (!(typeof tx.decryptMessage === 'function')) {
                _context37.n = 4;
                break;
              }
              _context37.n = 4;
              return tx.decryptMessage(this.app);
            case 4:
              message = ((_tx$returnMessage9 = tx.returnMessage) === null || _tx$returnMessage9 === void 0 ? void 0 : _tx$returnMessage9.call(tx)) || tx.msg || {};
              signature = tx.signature != null ? String(tx.signature) : '';
              if (!(!signature || message.module && message.module !== this.name || message.request !== 'create tweet' || ((_this$app$modules4 = this.app.modules) === null || _this$app$modules4 === void 0 || (_this$app$modules4$mo = _this$app$modules4.moderate) === null || _this$app$modules4$mo === void 0 ? void 0 : _this$app$modules4$mo.call(_this$app$modules4, tx, this.name)) === -1)) {
                _context37.n = 5;
                break;
              }
              return _context37.a(3, 6);
            case 5:
              tweet = Tweets.getTweet(this, signature) || this.profile_tweets[signature];
              if (tweet) {
                tweet.updateFromTransaction(tx);
              } else {
                tweet = new Tweet(this.app, this, tx);
                this.profile_tweets[signature] = tweet;
              }
              cached.push(tweet);
            case 6:
              _context37.n = 2;
              break;
            case 7:
              _context37.n = 9;
              break;
            case 8:
              _context37.p = 8;
              _t5 = _context37.v;
              _iterator20.e(_t5);
            case 9:
              _context37.p = 9;
              _iterator20.f();
              return _context37.f(9);
            case 10:
              return _context37.a(2, cached);
          }
        }, _callee37, this, [[1, 8, 9, 10]]);
      }));
      function cacheProfileTweetTransactions() {
        return _cacheProfileTweetTransactions.apply(this, arguments);
      }
      return cacheProfileTweetTransactions;
    }()
  }, {
    key: "returnTweetSignatureFromLocation",
    value: function returnTweetSignatureFromLocation() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var currentLocation = location || (typeof window !== 'undefined' ? window.location : null);
      if (!currentLocation) {
        return '';
      }
      var prefix = "/".concat(encodeURI(this.returnSlug()), "/tweet/");
      var pathname = currentLocation.pathname || '';
      if (pathname.startsWith(prefix)) {
        var encodedSignature = pathname.slice(prefix.length).split('/')[0];
        try {
          return decodeURIComponent(encodedSignature);
        } catch (err) {
          return '';
        }
      }
      var params = new URLSearchParams(currentLocation.search || '');
      return params.get('tweet_id') || params.get('thread_id') || '';
    }
  }, {
    key: "loadArchiveTransactions",
    value: function loadArchiveTransactions(query) {
      var archivePeer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'localhost';
      var timeoutMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
      return this.loadArchiveTransactionsWithStatus(query, archivePeer, timeoutMs).then(function (_ref10) {
        var transactions = _ref10.transactions;
        return transactions;
      });
    }
  }, {
    key: "loadArchiveTransactionsWithStatus",
    value: function loadArchiveTransactionsWithStatus(query) {
      var _this18 = this;
      var archivePeer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'localhost';
      var timeoutMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
      return new Promise(function (resolve) {
        var settled = false;
        var timer = null;
        var finish = function finish(status) {
          var txs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          if (settled) {
            return;
          }
          settled = true;
          if (timer) {
            clearTimeout(timer);
          }
          resolve({
            status: status,
            transactions: Array.isArray(txs) ? txs : [],
            error: error
          });
        };
        timer = setTimeout(function () {
          return finish('timeout');
        }, timeoutMs);
        try {
          Promise.resolve(_this18.app.storage.loadTransactions(query, function (txs) {
            return finish('loaded', txs);
          }, archivePeer))["catch"](function (err) {
            return finish('error', [], err);
          });
        } catch (err) {
          finish('error', [], err);
        }
      });
    }
  }, {
    key: "addLoadedTweetTransactions",
    value: function () {
      var _addLoadedTweetTransactions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee38() {
        var txs,
          _iterator21,
          _step21,
          tx,
          _args38 = arguments,
          _t6;
        return _regenerator().w(function (_context38) {
          while (1) switch (_context38.p = _context38.n) {
            case 0:
              txs = _args38.length > 0 && _args38[0] !== undefined ? _args38[0] : [];
              _iterator21 = _createForOfIteratorHelper(txs);
              _context38.p = 1;
              _iterator21.s();
            case 2:
              if ((_step21 = _iterator21.n()).done) {
                _context38.n = 6;
                break;
              }
              tx = _step21.value;
              if (tx) {
                _context38.n = 3;
                break;
              }
              return _context38.a(3, 5);
            case 3:
              if (!(typeof tx.decryptMessage === 'function')) {
                _context38.n = 4;
                break;
              }
              _context38.n = 4;
              return tx.decryptMessage(this.app);
            case 4:
              this.addTweet(tx);
            case 5:
              _context38.n = 2;
              break;
            case 6:
              _context38.n = 8;
              break;
            case 7:
              _context38.p = 7;
              _t6 = _context38.v;
              _iterator21.e(_t6);
            case 8:
              _context38.p = 8;
              _iterator21.f();
              return _context38.f(8);
            case 9:
              return _context38.a(2);
          }
        }, _callee38, this, [[1, 7, 8, 9]]);
      }));
      function addLoadedTweetTransactions() {
        return _addLoadedTweetTransactions.apply(this, arguments);
      }
      return addLoadedTweetTransactions;
    }()
  }, {
    key: "returnTweetArchivePeers",
    value: function returnTweetArchivePeers() {
      var archivePeers = ['localhost'];
      var publicKeys = new Set();
      var _iterator22 = _createForOfIteratorHelper(this.peers || []),
        _step22;
      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var peerObject = _step22.value;
          var archivePeer = peerObject === null || peerObject === void 0 ? void 0 : peerObject.peer;
          if (!archivePeer || archivePeer === 'localhost') {
            continue;
          }
          var publicKey = archivePeer.publicKey || peerObject.publicKey || '';
          if (publicKey && !publicKeys.has(publicKey)) {
            publicKeys.add(publicKey);
            archivePeers.push(archivePeer);
          }
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
      return archivePeers;
    }
  }, {
    key: "returnTweetArchivePeerLabel",
    value: function returnTweetArchivePeerLabel(peer) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (peer === 'localhost') {
        return 'localhost';
      }
      return (peer === null || peer === void 0 ? void 0 : peer.publicKey) || "peer-".concat(index);
    }
  }, {
    key: "loadTweetArchivePhase",
    value: function () {
      var _loadTweetArchivePhase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee40(signature, query, phase, archivePeers) {
        var _this19 = this;
        return _regenerator().w(function (_context40) {
          while (1) switch (_context40.n) {
            case 0:
              return _context40.a(2, Promise.all(archivePeers.map(/*#__PURE__*/function () {
                var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee39(peer, index) {
                  var result;
                  return _regenerator().w(function (_context39) {
                    while (1) switch (_context39.n) {
                      case 0:
                        _context39.n = 1;
                        return _this19.loadArchiveTransactionsWithStatus(query, peer);
                      case 1:
                        result = _context39.v;
                        console.info('RedSquare tweet archive lookup', {
                          signature: signature,
                          phase: phase,
                          peer: _this19.returnTweetArchivePeerLabel(peer, index),
                          status: result.status,
                          result_count: result.transactions.length
                        });
                        return _context39.a(2, result);
                    }
                  }, _callee39);
                }));
                return function (_x34, _x35) {
                  return _ref11.apply(this, arguments);
                };
              }())));
          }
        }, _callee40);
      }));
      function loadTweetArchivePhase(_x30, _x31, _x32, _x33) {
        return _loadTweetArchivePhase.apply(this, arguments);
      }
      return loadTweetArchivePhase;
    }()
  }, {
    key: "loadTweetThread",
    value: function () {
      var _loadTweetThread = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee41(signature) {
        var targetSignature, archivePeers, targetResults, _iterator23, _step23, result, target, returnedTarget, lookupFailed, threadId, threadResults, _iterator24, _step24, _result, _t7, _t8;
        return _regenerator().w(function (_context41) {
          while (1) switch (_context41.p = _context41.n) {
            case 0:
              targetSignature = String(signature || '');
              if (targetSignature) {
                _context41.n = 1;
                break;
              }
              return _context41.a(2, {
                status: 'unavailable',
                reason: 'invalid-signature',
                tweet: null
              });
            case 1:
              archivePeers = this.returnTweetArchivePeers();
              targetResults = [];
              if (this.hasTweet(targetSignature)) {
                _context41.n = 9;
                break;
              }
              _context41.n = 2;
              return this.loadTweetArchivePhase(targetSignature, {
                sig: targetSignature,
                field1: 'RedSquare',
                flagged_ne: 1
              }, 'target', archivePeers);
            case 2:
              targetResults = _context41.v;
              _iterator23 = _createForOfIteratorHelper(targetResults);
              _context41.p = 3;
              _iterator23.s();
            case 4:
              if ((_step23 = _iterator23.n()).done) {
                _context41.n = 6;
                break;
              }
              result = _step23.value;
              _context41.n = 5;
              return this.addLoadedTweetTransactions(result.transactions);
            case 5:
              _context41.n = 4;
              break;
            case 6:
              _context41.n = 8;
              break;
            case 7:
              _context41.p = 7;
              _t7 = _context41.v;
              _iterator23.e(_t7);
            case 8:
              _context41.p = 8;
              _iterator23.f();
              return _context41.f(8);
            case 9:
              target = this.getTweet(targetSignature);
              if (targetResults.length) {
                console.info('RedSquare tweet archive ingestion', {
                  signature: targetSignature,
                  phase: 'target',
                  accepted: Boolean(target),
                  result_count: targetResults.reduce(function (count, result) {
                    return count + result.transactions.length;
                  }, 0)
                });
              }
              if (target) {
                _context41.n = 10;
                break;
              }
              returnedTarget = targetResults.some(function (result) {
                return result.transactions.some(function (tx) {
                  return String((tx === null || tx === void 0 ? void 0 : tx.signature) || '') === targetSignature;
                });
              });
              lookupFailed = targetResults.some(function (result) {
                return result.status !== 'loaded';
              });
              return _context41.a(2, {
                status: lookupFailed ? 'error' : 'unavailable',
                reason: returnedTarget ? 'rejected' : lookupFailed ? 'lookup-failed' : 'not-found',
                tweet: null
              });
            case 10:
              threadId = target.thread_id || target.signature;
              _context41.n = 11;
              return this.loadTweetArchivePhase(targetSignature, {
                field1: 'RedSquare',
                field5: threadId,
                flagged_ne: 1,
                limit: 100
              }, 'thread', archivePeers);
            case 11:
              threadResults = _context41.v;
              _iterator24 = _createForOfIteratorHelper(threadResults);
              _context41.p = 12;
              _iterator24.s();
            case 13:
              if ((_step24 = _iterator24.n()).done) {
                _context41.n = 15;
                break;
              }
              _result = _step24.value;
              _context41.n = 14;
              return this.addLoadedTweetTransactions(_result.transactions);
            case 14:
              _context41.n = 13;
              break;
            case 15:
              _context41.n = 17;
              break;
            case 16:
              _context41.p = 16;
              _t8 = _context41.v;
              _iterator24.e(_t8);
            case 17:
              _context41.p = 17;
              _iterator24.f();
              return _context41.f(17);
            case 18:
              console.info('RedSquare tweet archive ingestion', {
                signature: targetSignature,
                phase: 'thread',
                accepted: Boolean(this.getTweet(targetSignature)),
                result_count: threadResults.reduce(function (count, result) {
                  return count + result.transactions.length;
                }, 0)
              });
              return _context41.a(2, {
                status: 'loaded',
                tweet: this.getTweet(targetSignature),
                partial: [].concat(_toConsumableArray(targetResults), _toConsumableArray(threadResults)).some(function (result) {
                  return result.status !== 'loaded';
                })
              });
          }
        }, _callee41, this, [[12, 16, 17, 18], [3, 7, 8, 9]]);
      }));
      function loadTweetThread(_x36) {
        return _loadTweetThread.apply(this, arguments);
      }
      return loadTweetThread;
    }()
  }, {
    key: "returnTweetSocial",
    value: function () {
      var _returnTweetSocial = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee42(signature, req) {
        var _tx$returnMessage0, _tx$from4, _message$data;
        var txs, tx, message, publicKey, username, origin, encodedSignature, basePath;
        return _regenerator().w(function (_context42) {
          while (1) switch (_context42.n) {
            case 0:
              if (signature) {
                _context42.n = 1;
                break;
              }
              return _context42.a(2, null);
            case 1:
              _context42.n = 2;
              return this.loadArchiveTransactions({
                sig: String(signature || ''),
                field1: 'RedSquare',
                flagged_ne: 1
              }, 'localhost');
            case 2:
              txs = _context42.v;
              tx = txs[0];
              if (tx) {
                _context42.n = 3;
                break;
              }
              return _context42.a(2, null);
            case 3:
              if (!(typeof tx.decryptMessage === 'function')) {
                _context42.n = 4;
                break;
              }
              _context42.n = 4;
              return tx.decryptMessage(this.app);
            case 4:
              message = ((_tx$returnMessage0 = tx.returnMessage) === null || _tx$returnMessage0 === void 0 ? void 0 : _tx$returnMessage0.call(tx)) || tx.msg || {};
              publicKey = ((_tx$from4 = tx.from) === null || _tx$from4 === void 0 || (_tx$from4 = _tx$from4[0]) === null || _tx$from4 === void 0 ? void 0 : _tx$from4.publicKey) || '';
              username = this.app.keychain.returnUsername(publicKey) || (publicKey ? "Anon-".concat(publicKey.slice(0, 6)) : 'Anonymous');
              origin = "".concat(req.protocol, "://").concat(req.get('host'));
              encodedSignature = encodeURIComponent(signature);
              basePath = "/".concat(encodeURI(this.returnSlug()));
              return _context42.a(2, {
                twitter: '@SaitoOfficial',
                title: "".concat(username, " posted on Saito \uD83D\uDFE5"),
                url: "".concat(origin).concat(basePath, "/tweet/").concat(encodedSignature),
                description: String(((_message$data = message.data) === null || _message$data === void 0 ? void 0 : _message$data.text) || ''),
                image: "".concat(origin).concat(basePath, "/og-image/").concat(encodedSignature)
              });
          }
        }, _callee42, this);
      }));
      function returnTweetSocial(_x37, _x38) {
        return _returnTweetSocial.apply(this, arguments);
      }
      return returnTweetSocial;
    }()
  }, {
    key: "returnShortLinkSocial",
    value: function () {
      var _returnShortLinkSocial = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee43(row, req) {
        var origin, target, basePath, prefix, signature, encodedSignature, _t9, _t0;
        return _regenerator().w(function (_context43) {
          while (1) switch (_context43.p = _context43.n) {
            case 0:
              origin = "".concat(req.protocol, "://").concat(req.get('host'));
              target = new URL((row === null || row === void 0 ? void 0 : row.link) || '', origin);
              basePath = "/".concat(encodeURI(this.returnSlug()));
              prefix = "".concat(basePath, "/tweet/");
              if (!(target.host !== req.get('host'))) {
                _context43.n = 1;
                break;
              }
              return _context43.a(2, null);
            case 1:
              signature = '';
              _context43.p = 2;
              if (target.pathname.startsWith(prefix)) {
                encodedSignature = target.pathname.slice(prefix.length).split('/')[0];
                signature = decodeURIComponent(encodedSignature);
              } else if (target.pathname === basePath || target.pathname === "".concat(basePath, "/")) {
                signature = target.searchParams.get('tweet_id') || target.searchParams.get('thread_id') || '';
              }
              if (!signature) {
                _context43.n = 4;
                break;
              }
              _context43.n = 3;
              return this.returnTweetSocial(signature, req);
            case 3:
              _t9 = _context43.v;
              _context43.n = 5;
              break;
            case 4:
              _t9 = null;
            case 5:
              return _context43.a(2, _t9);
            case 6:
              _context43.p = 6;
              _t0 = _context43.v;
              return _context43.a(2, null);
          }
        }, _callee43, this, [[2, 6]]);
      }));
      function returnShortLinkSocial(_x39, _x40) {
        return _returnShortLinkSocial.apply(this, arguments);
      }
      return returnShortLinkSocial;
    }()
  }, {
    key: "dataUriToImage",
    value: function dataUriToImage(dataUri) {
      var match = /^data:(image\/(?:png|jpe?g|gif|webp|svg\+xml|png\+xml));base64,([a-z\d+/=]+)$/i.exec(String(dataUri || ''));
      if (!match) {
        return null;
      }
      var mimeType = match[1].toLowerCase() === 'image/png+xml' ? 'image/png' : match[1];
      return {
        mimeType: mimeType,
        buffer: Buffer.from(match[2], 'base64')
      };
    }
  }, {
    key: "returnTweetImage",
    value: function () {
      var _returnTweetImage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee44(signature) {
        var _tx$returnMessage1, _message$data2, _tx$from5;
        var txs, tx, message, tweetImage, publicKey;
        return _regenerator().w(function (_context44) {
          while (1) switch (_context44.n) {
            case 0:
              if (signature) {
                _context44.n = 1;
                break;
              }
              return _context44.a(2, null);
            case 1:
              _context44.n = 2;
              return this.loadArchiveTransactions({
                sig: String(signature || ''),
                field1: 'RedSquare',
                flagged_ne: 1
              }, 'localhost');
            case 2:
              txs = _context44.v;
              tx = txs[0];
              if (tx) {
                _context44.n = 3;
                break;
              }
              return _context44.a(2, null);
            case 3:
              if (!(typeof tx.decryptMessage === 'function')) {
                _context44.n = 4;
                break;
              }
              _context44.n = 4;
              return tx.decryptMessage(this.app);
            case 4:
              message = ((_tx$returnMessage1 = tx.returnMessage) === null || _tx$returnMessage1 === void 0 ? void 0 : _tx$returnMessage1.call(tx)) || tx.msg || {};
              tweetImage = this.dataUriToImage((_message$data2 = message.data) === null || _message$data2 === void 0 || (_message$data2 = _message$data2.images) === null || _message$data2 === void 0 ? void 0 : _message$data2[0]);
              if (!tweetImage) {
                _context44.n = 5;
                break;
              }
              return _context44.a(2, tweetImage);
            case 5:
              publicKey = ((_tx$from5 = tx.from) === null || _tx$from5 === void 0 || (_tx$from5 = _tx$from5[0]) === null || _tx$from5 === void 0 ? void 0 : _tx$from5.publicKey) || '';
              return _context44.a(2, this.dataUriToImage(this.app.keychain.returnIdenticon(publicKey, 'png')));
          }
        }, _callee44, this);
      }));
      function returnTweetImage(_x41) {
        return _returnTweetImage.apply(this, arguments);
      }
      return returnTweetImage;
    }()
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var alternative_slug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var webdir = "".concat(__dirname, "/web");
      var uri = alternative_slug || '/' + encodeURI(this.returnSlug());
      var routeBase = uri.endsWith('/') ? uri.slice(0, -1) : uri;
      var self = this;
      expressapp.use(uri, express["static"](webdir));
      expressapp.get("".concat(routeBase, "/tweet/:signature"), /*#__PURE__*/function () {
        var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee45(req, res) {
          var social, html, _t1, _t10;
          return _regenerator().w(function (_context45) {
            while (1) switch (_context45.p = _context45.n) {
              case 0:
                social = self.social;
                _context45.p = 1;
                _context45.n = 2;
                return self.returnTweetSocial(req.params.signature, req);
              case 2:
                _t1 = _context45.v;
                if (_t1) {
                  _context45.n = 3;
                  break;
                }
                _t1 = self.social;
              case 3:
                social = _t1;
                _context45.n = 5;
                break;
              case 4:
                _context45.p = 4;
                _t10 = _context45.v;
                console.error('RedSquare tweet metadata lookup failed:', _t10);
              case 5:
                html = index(app, self, app.build_number, social);
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context45.a(2, res.send(html));
            }
          }, _callee45, null, [[1, 4]]);
        }));
        return function (_x42, _x43) {
          return _ref12.apply(this, arguments);
        };
      }());
      expressapp.get("".concat(routeBase, "/user/:publicKey"), function (req, res) {
        var html = index(app, self, app.build_number);
        res.setHeader('Content-type', 'text/html');
        res.charset = 'UTF-8';
        return res.send(html);
      });
      expressapp.get("".concat(routeBase, "/og-image/:signature"), /*#__PURE__*/function () {
        var _ref13 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee46(req, res) {
          var image, _t11;
          return _regenerator().w(function (_context46) {
            while (1) switch (_context46.p = _context46.n) {
              case 0:
                image = null;
                _context46.p = 1;
                _context46.n = 2;
                return self.returnTweetImage(req.params.signature);
              case 2:
                image = _context46.v;
                _context46.n = 4;
                break;
              case 3:
                _context46.p = 3;
                _t11 = _context46.v;
                console.error('RedSquare tweet image lookup failed:', _t11);
              case 4:
                if (image) {
                  _context46.n = 5;
                  break;
                }
                return _context46.a(2, res.redirect(302, self.social.image));
              case 5:
                res.writeHead(200, {
                  'Content-Type': image.mimeType,
                  'Content-Length': image.buffer.length
                });
                return _context46.a(2, res.end(image.buffer));
            }
          }, _callee46, null, [[1, 3]]);
        }));
        return function (_x44, _x45) {
          return _ref13.apply(this, arguments);
        };
      }());
      expressapp.get(uri, function (req, res) {
        var _req$query, _req$query2, _req$query3, _req$query4;
        var imageSignature = (_req$query = req.query) === null || _req$query === void 0 ? void 0 : _req$query.og_img_sig;
        var tweetSignature = ((_req$query2 = req.query) === null || _req$query2 === void 0 ? void 0 : _req$query2.tweet_id) || ((_req$query3 = req.query) === null || _req$query3 === void 0 ? void 0 : _req$query3.thread_id);
        var userPublicKey = (_req$query4 = req.query) === null || _req$query4 === void 0 ? void 0 : _req$query4.user_id;
        if (imageSignature) {
          return res.redirect(301, "".concat(routeBase, "/og-image/").concat(encodeURIComponent(String(imageSignature))));
        }
        if (tweetSignature) {
          return res.redirect(301, "".concat(routeBase, "/tweet/").concat(encodeURIComponent(String(tweetSignature))));
        }
        if (userPublicKey) {
          return res.redirect(301, "".concat(routeBase, "/user/").concat(encodeURIComponent(String(userPublicKey))));
        }
        var html = index(app, self, app.build_number);
        res.setHeader('Content-type', 'text/html');
        res.charset = 'UTF-8';
        return res.send(html);
      });
    }

    //
    // Development-only fixtures for exercising the UI. Not part of production loading.
    //
  }, {
    key: "returnMockTransactions",
    value: function returnMockTransactions() {
      var _this20 = this;
      var authors = ['redsquare-mock-pk-saito', 'redsquare-mock-pk-alice', 'redsquare-mock-pk-bob', 'redsquare-mock-pk-carol'];
      var now = Date.now();
      var mockSig = function mockSig(seed) {
        return "".concat(seed.toString(16).padStart(64, '0'));
      };
      var build = function build(_ref14) {
        var seed = _ref14.seed,
          _ref14$author = _ref14.author,
          author = _ref14$author === void 0 ? 0 : _ref14$author,
          text = _ref14.text,
          _ref14$parent_id = _ref14.parent_id,
          parent_id = _ref14$parent_id === void 0 ? '' : _ref14$parent_id,
          _ref14$thread_id = _ref14.thread_id,
          thread_id = _ref14$thread_id === void 0 ? '' : _ref14$thread_id,
          _ref14$images = _ref14.images,
          images = _ref14$images === void 0 ? [] : _ref14$images,
          _ref14$embedded = _ref14.embedded,
          embedded = _ref14$embedded === void 0 ? null : _ref14$embedded,
          _ref14$minutesAgo = _ref14.minutesAgo,
          minutesAgo = _ref14$minutesAgo === void 0 ? 0 : _ref14$minutesAgo,
          _ref14$optional = _ref14.optional,
          optional = _ref14$optional === void 0 ? {} : _ref14$optional;
        var signature = mockSig(seed);
        var publicKey = authors[author % authors.length];
        var timestamp = now - minutesAgo * 60 * 1000;
        var data = {
          text: text,
          images: images,
          parent_id: parent_id,
          thread_id: thread_id || (parent_id ? '' : signature)
        };
        if (embedded) {
          data.embedded = embedded;
        }
        if (parent_id && thread_id) {
          data.thread_id = thread_id;
        }
        return {
          signature: signature,
          timestamp: timestamp,
          from: [{
            publicKey: publicKey,
            amount: '0',
            type: 1,
            index: 0,
            blockId: '0',
            txOrdinal: '0'
          }],
          msg: {
            module: _this20.name,
            request: 'create tweet',
            data: data
          },
          optional: _objectSpread({
            num_likes: 12,
            num_replies: 3,
            num_retweets: 5
          }, optional)
        };
      };
      var normalSig = mockSig(1);
      var threadRootSig = mockSig(2);
      var threadReplySig = mockSig(3);
      var embeddedSig = mockSig(8);
      return [build({
        seed: 1,
        author: 0,
        minutesAgo: 60,
        text: 'Welcome to RedSquare — a normal timeline post for UI development.'
      }), build({
        seed: 5,
        author: 1,
        minutesAgo: 55,
        parent_id: normalSig,
        thread_id: normalSig,
        text: 'This is a reply to the post above.',
        optional: {
          num_likes: 4,
          num_replies: 0,
          num_retweets: 1
        }
      }), build({
        seed: 2,
        author: 2,
        minutesAgo: 45,
        text: 'Thread root — open this post to walk the critical reply chain.'
      }), build({
        seed: 3,
        author: 3,
        minutesAgo: 40,
        parent_id: threadRootSig,
        thread_id: threadRootSig,
        text: 'First reply in the thread.',
        optional: {
          num_likes: 6,
          num_replies: 1,
          num_retweets: 0
        }
      }), build({
        seed: 4,
        author: 1,
        minutesAgo: 35,
        parent_id: threadReplySig,
        thread_id: threadRootSig,
        text: 'Second reply — continues the critical path.',
        optional: {
          num_likes: 2,
          num_replies: 0,
          num_retweets: 0
        }
      }), build({
        seed: 6,
        author: 0,
        minutesAgo: 25,
        text: 'Quote-posting another tweet below.',
        embedded: {
          signature: embeddedSig,
          publicKey: authors[2],
          text: 'Embedded tweet card — quoted content rendered inline.',
          created_at: now - 30 * 60 * 1000,
          images: [],
          likes: 9,
          replies: 2,
          retweets: 1
        }
      }), build({
        seed: 7,
        author: 3,
        minutesAgo: 10,
        text: 'Image gallery fixture with four placeholders.',
        images: ['/saito/img/dreamscape.png', '/saito/img/dreamscape.png', '/saito/img/dreamscape.png', '/saito/img/dreamscape.png'],
        optional: {
          num_likes: 28,
          num_replies: 6,
          num_retweets: 11
        }
      })];
    }
  }]);
}(ModTemplate);
module.exports = RedSquare;